<template>
  <div>
    <section
      v-if="property && variants.v4 !== variant"
      class="n-section-primary !tw-pb-0 !tw-pt-36"
      :style="{
        backgroundColor: vars.backgroundColor ? `var(--c-${vars.backgroundColor})` : 'var(--c-section_secondary)',
      }"
    >
      <div
        v-if="company.company_key === 'harrisonshomes'"
        class="property-detail-info tw-flex tw-w-full tw-flex-col tw-py-12"
      >
        <div class="tw-flex tw-justify-between tw-pb-6">
          <library-properties-back-to-all-properties-navbar :text="vars.backButtonText" color="var(--c-primary)" />
        </div>
        <div class="tw-grid tw-grid-cols-12 tw-items-start tw-justify-between">
          <div class="tw-col-span-12 tw-flex tw-flex-col lg:tw-col-span-7 lg:tw-gap-y-4">
            <h2 class="tw-uppercase">{{ property.advert_heading }}</h2>
            <div class="address tw-mt-2 tw-flex tw-items-center tw-gap-1">
              <h6 class="tw-uppercase" style="color: var(--c-text_primary) !important">
                {{ property.display_address }}
              </h6>
            </div>
            <div v-if="!property.is_locked" class="tw-mt-3 tw-flex tw-items-center tw-gap-1">
              <div class="rooms tw-flex tw-flex-row tw-items-center tw-gap-4">
                <h6>{{ property.bedroom }} BE</h6>
                <h6>{{ property.bathroom }} BA</h6>
                <h6>{{ property.reception }} RE</h6>
              </div>
            </div>
            <div
              class="tw-flex tw-flex-col tw-items-start tw-gap-5 tw-py-5 md:tw-flex-row md:tw-items-center lg:tw-mt-8"
            >
              <button v-if="!property.is_locked" class="n-primary" @click="onSendLead()">BOOK A VIEWING</button>
              <!-- <button @click="href('cinematic_videography')" class="n-secondary">CINEMATIC VIDEOGRAPHY</button> -->
              <div
                class="tw-flex tw-h-12 tw-w-12 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full"
                style="background-color: transparent; border: 1px solid var(--c-primary)"
                @click="onShared()"
              >
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.5386 3C19.9534 2.9998 19.3753 3.12802 18.845 3.37562C18.3147 3.62321 17.8452 3.98414 17.4697 4.43296C17.0941 4.88177 16.8216 5.40752 16.6713 5.97314C16.5211 6.53875 16.4968 7.13044 16.6002 7.70646L10.7786 11.7828C10.7495 11.8029 10.7216 11.8247 10.6949 11.848C10.1043 11.3863 9.39588 11.0999 8.65036 11.0214C7.90484 10.9429 7.15226 11.0754 6.47844 11.404C5.80462 11.7325 5.23669 12.2438 4.83939 12.8795C4.4421 13.5152 4.23145 14.2497 4.23145 14.9994C4.23145 15.749 4.4421 16.4836 4.83939 17.1193C5.23669 17.755 5.80462 18.2663 6.47844 18.5948C7.15226 18.9233 7.90484 19.0559 8.65036 18.9774C9.39588 18.8989 10.1043 18.6125 10.6949 18.1508C10.7215 18.1745 10.7495 18.1967 10.7786 18.2172L16.6002 22.2935C16.4273 23.2569 16.6137 24.2502 17.1241 25.0854C17.6344 25.9206 18.4333 26.5397 19.3694 26.8255C20.3055 27.1113 21.3139 27.0439 22.2037 26.6362C23.0935 26.2284 23.8029 25.5086 24.1976 24.613C24.5923 23.7173 24.645 22.708 24.3456 21.7762C24.0461 20.8443 23.4155 20.0546 22.5729 19.5565C21.7304 19.0584 20.7344 18.8865 19.7737 19.0734C18.8129 19.2603 17.954 19.7929 17.3595 20.5705L11.8469 16.712C12.0931 16.1926 12.2309 15.6129 12.2309 15C12.2309 14.3871 12.0931 13.8062 11.8469 13.288L17.3608 9.42831C17.7738 9.96895 18.3179 10.3953 18.9416 10.6671C19.5654 10.9388 20.2481 11.047 20.9253 10.9813C21.6024 10.9157 22.2517 10.6784 22.8116 10.2919C23.3715 9.90545 23.8236 9.38253 24.1251 8.77263C24.4266 8.16273 24.5676 7.48601 24.5347 6.80646C24.5017 6.1269 24.296 5.46697 23.937 4.88907C23.5779 4.31117 23.0774 3.8344 22.4828 3.50385C21.8881 3.17329 21.219 2.99988 20.5386 3ZM18.3848 7C18.3848 6.42876 18.6117 5.88093 19.0156 5.477C19.4195 5.07308 19.9674 4.84615 20.5386 4.84615C21.1099 4.84615 21.6577 5.07308 22.0616 5.477C22.4655 5.88093 22.6925 6.42876 22.6925 7C22.6925 7.57124 22.4655 8.11907 22.0616 8.523C21.6577 8.92692 21.1099 9.15385 20.5386 9.15385C19.9674 9.15385 19.4195 8.92692 19.0156 8.523C18.6117 8.11907 18.3848 7.57124 18.3848 7ZM8.23093 12.8462C7.6597 12.8462 7.11186 13.0731 6.70793 13.477C6.30401 13.8809 6.07709 14.4288 6.07709 15C6.07709 15.5712 6.30401 16.1191 6.70793 16.523C7.11186 16.9269 7.6597 17.1538 8.23093 17.1538C8.80217 17.1538 9.35001 16.9269 9.75393 16.523C10.1579 16.1191 10.3848 15.5712 10.3848 15C10.3848 14.4288 10.1579 13.8809 9.75393 13.477C9.35001 13.0731 8.80217 12.8462 8.23093 12.8462ZM20.5386 20.8462C19.9674 20.8462 19.4195 21.0731 19.0156 21.477C18.6117 21.8809 18.3848 22.4288 18.3848 23C18.3848 23.5712 18.6117 24.1191 19.0156 24.523C19.4195 24.9269 19.9674 25.1538 20.5386 25.1538C21.1099 25.1538 21.6577 24.9269 22.0616 24.523C22.4655 24.1191 22.6925 23.5712 22.6925 23C22.6925 22.4288 22.4655 21.8809 22.0616 21.477C21.6577 21.0731 21.1099 20.8462 20.5386 20.8462Z"
                    fill="var(--c-primary)"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div
            class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between lg:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8"
          >
            <div
              class="tw-flex tw-w-full tw-items-center tw-justify-between max-lg:tw-pt-4 lg:tw-justify-end lg:tw-gap-8"
            >
              <div v-if="property.price">
                <h3 v-if="property.price.type.name" class="tw-uppercase">
                  {{ property.price.type.name }}
                </h3>
                <h2>{{ property.price.price }}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- GALLERY: START -->
      <template v-if="vars.galleryVersionText === 'v2'">
        <div
          v-if="property.is_rent"
          class="tw-mt-16 tw-w-full"
          :class="!isMobileDevice ? 'tw-grid tw-grid-cols-12 tw-gap-x-3' : ''"
        >
          <div
            v-if="!isMobileDevice"
            class="property-detail-image-container tw-col-span-12 tw-h-full tw-w-full lg:tw-col-span-6"
            @click="onClickedImage(null)"
          >
            <library-image
              v-if="primaryFivePhotos[0].background"
              :src="primaryFivePhotos[0].background"
              image-class="tw-h-full tw-cursor-pointer"
              alt="property first image"
              :title="property.advert_heading"
              @click="onClickedImage(primaryFivePhotos[0])"
              :design-width="964"
              :design-height="643"
              :style="`border-radius: var(--rounded)`"
            >
              <template #overlay-item>
                <div class="nc-first-image-overlay-item">
                  <div v-if="property && property.medias" style="" class="tw-text-md tw-px-2 tw-py-1">
                    1/{{ property.medias.length }}
                  </div>
                </div>
              </template>
            </library-image>
          </div>
          <div
            v-if="!isMobileDevice"
            class="tw-col-span-12 tw-grid tw-h-full tw-grid-cols-12 tw-gap-x-3 md:tw-col-span-6"
          >
            <div class="tw-col-span-6 tw-flex tw-flex-row tw-gap-y-3 md:tw-flex-col">
              <library-image
                v-if="primaryFivePhotos[1].background"
                :src="primaryFivePhotos[1].background"
                alt="property first image"
                image-class="tw-cursor-pointer"
                @click="onClickedImage(primaryFivePhotos[1])"
                :title="property.advert_heading"
                :design-width="364"
                :design-height="246"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />

              <library-image
                v-if="primaryFivePhotos[2].background"
                :src="primaryFivePhotos[2].background"
                alt="property second image"
                image-class="tw-cursor-pointer"
                @click="onClickedImage(primaryFivePhotos[2])"
                :title="property.advert_heading"
                :design-width="364"
                :design-height="246"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />
            </div>
            <div class="tw-col-span-6 tw-flex tw-flex-row tw-gap-y-3 md:tw-flex-col">
              <library-image
                v-if="primaryFivePhotos[3].background"
                :src="primaryFivePhotos[3].background"
                image-class="tw-cursor-pointer"
                @click="onClickedImage(primaryFivePhotos[3])"
                :design-width="364"
                :design-height="246"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />
              <library-image
                v-if="primaryFivePhotos[4].background"
                :src="primaryFivePhotos[4].background"
                image-class="tw-cursor-pointer"
                @click="onClickedImage(primaryFivePhotos[4])"
                :design-width="364"
                :design-height="246"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />
            </div>
          </div>
          <div v-else-if="isMobileDevice" class="n-main-container tw-w-screen">
            <Swiper
              :modules="[SwiperNavigation]"
              :pagination="true"
              :slides-per-view="1"
              :space-between="1"
              effect="fade"
              :clickable="true"
              :navigation="{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              }"
              :loop="true"
              class="tw-w-full"
              @swiper="onSwiper"
            >
              <SwiperSlide v-for="(item, index) in primaryFivePhotos" :key="index" class="tw-w-full">
                <library-image
                  :src="item.background"
                  @click="onClickedImage(item)"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
              </SwiperSlide>
              <div class="tw-flex tw-items-center tw-justify-between">
                <div class="swiper-button-prev tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3">
                  <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18.75 7.5H5.25C4.83 7.5 4.5 7.17 4.5 6.75C4.5 6.33 4.83 6 5.25 6H18.75C19.17 6 19.5 6.33 19.5 6.75C19.5 7.17 19.17 7.5 18.75 7.5Z"
                      fill="black"
                    />
                    <path
                      d="M9 12.75C8.90164 12.7512 8.80411 12.7318 8.71369 12.6931C8.62328 12.6543 8.54197 12.5971 8.475 12.525L3.225 7.275C2.925 6.975 2.925 6.51 3.225 6.21L8.475 0.975C8.775 0.675 9.24 0.675 9.54 0.975C9.84 1.275 9.84 1.74 9.54 2.04L4.815 6.765L9.54 11.49C9.84 11.79 9.84 12.255 9.54 12.555C9.39 12.705 9.195 12.78 9.015 12.78L9 12.75Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div class="swiper-button-next tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3">
                  <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M5.25 7.5H18.75C19.17 7.5 19.5 7.17 19.5 6.75C19.5 6.33 19.17 6 18.75 6H5.25C4.83 6 4.5 6.33 4.5 6.75C4.5 7.17 4.83 7.5 5.25 7.5Z"
                      fill="black"
                    />
                    <path
                      d="M15 12.75C15.0984 12.7512 15.1959 12.7318 15.2863 12.6931C15.3767 12.6543 15.458 12.5971 15.525 12.525L20.775 7.275C21.075 6.975 21.075 6.51 20.775 6.21L15.525 0.975C15.225 0.675 14.76 0.675 14.46 0.975C14.16 1.275 14.16 1.74 14.46 2.04L19.185 6.765L14.46 11.49C14.16 11.79 14.16 12.255 14.46 12.555C14.61 12.705 14.805 12.78 14.985 12.78L15 12.75Z"
                      fill="black"
                    />
                  </svg>
                </div>
              </div>
            </Swiper>
          </div>
        </div>
        <!-- Sale -->
        <div v-else class="tw-w-screen tw-gap-x-1 tw-px-4">
          <Swiper
            :modules="[SwiperNavigation]"
            :pagination="true"
            :centered-slides="true"
            :center-insufficient-slides="true"
            :loop="true"
            :initial-slide="0"
            :slides-per-view="2"
            :space-between="16"
            effect="fade"
            :clickable="true"
            :navigation="{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }"
            :breakpoints="{
              320: {
                slidesPerView: 1,
                spaceBetween: 8,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
            }"
            class="tw-w-full lg:tw-w-[100%]"
            @swiper="onSwiper"
          >
            <SwiperSlide
              v-for="(item, index) in property.medias.filter(
                (media) => !media.isVirtualTour && !media.background.includes('ytimg'),
              )"
              :key="index"
            >
              <div v-if="!item.background.includes('ytimg')">
                <library-image
                  v-if="!item.isVirtualTour || (!item.background.includes('ytimg') && item.background)"
                  :src="item.background"
                  @click="onClickedImage(item)"
                  :design-width="964"
                  :design-height="643"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                >
                  <template #overlay-item>
                    <div v-if="index === 0">
                      <div class="nc-first-image-overlay-item">
                        <div v-if="property && property.medias" style="" class="tw-text-md tw-px-2 tw-py-1">
                          1/{{ property.medias.length }}
                        </div>
                      </div>
                    </div>
                  </template>
                </library-image>
              </div>
            </SwiperSlide>

            <div class="tw-flex tw-items-center tw-justify-between">
              <div
                class="swiper-button-prev tw-cursor-pointer tw-rounded-full tw-bg-white tw-px-2 tw-py-5 lg:!tw-left-16 lg:tw-px-2"
              >
                <svg width="33" height="12" viewBox="0 0 33 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M31.5 5.25H32.25V6.75H31.5V5.25ZM0.96967 6.53033C0.676777 6.23744 0.676777 5.76256 0.96967 5.46967L5.74264 0.696699C6.03553 0.403806 6.51041 0.403806 6.8033 0.696699C7.09619 0.989592 7.09619 1.46447 6.8033 1.75736L2.56066 6L6.8033 10.2426C7.09619 10.5355 7.09619 11.0104 6.8033 11.3033C6.51041 11.5962 6.03553 11.5962 5.74264 11.3033L0.96967 6.53033ZM31.5 6.75H1.5V5.25H31.5V6.75Z"
                    fill="#545454"
                  />
                </svg>
              </div>
              <div
                class="swiper-button-next tw-cursor-pointer tw-rounded-full tw-bg-white tw-px-2 tw-py-5 lg:!tw-right-16 lg:tw-px-2"
              >
                <svg width="33" height="12" viewBox="0 0 33 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.5 5.25H0.75V6.75H1.5V5.25ZM32.0303 6.53033C32.3232 6.23744 32.3232 5.76256 32.0303 5.46967L27.2574 0.696699C26.9645 0.403806 26.4896 0.403806 26.1967 0.696699C25.9038 0.989593 25.9038 1.46447 26.1967 1.75736L30.4393 6L26.1967 10.2426C25.9038 10.5355 25.9038 11.0104 26.1967 11.3033C26.4896 11.5962 26.9645 11.5962 27.2574 11.3033L32.0303 6.53033ZM1.5 6.75H31.5V5.25H1.5V6.75Z"
                    fill="#545454"
                  />
                </svg>
              </div>
            </div>
          </Swiper>
        </div>
      </template>
      <!-- GALLERY: END -->
      <div
        v-if="company.company_key !== 'harrisonshomes'"
        class="property-detail-info tw-flex tw-w-full tw-flex-col tw-py-12"
      >
        <div class="tw-flex tw-justify-between tw-pb-6">
          <library-properties-back-to-all-properties-navbar :text="vars.backButtonText" color="var(--c-primary)" />
        </div>
        <div class="tw-grid tw-grid-cols-12 tw-items-start tw-justify-between">
          <div class="tw-col-span-12 tw-flex tw-flex-col lg:tw-col-span-7">
            <h2>{{ property.advert_heading }}</h2>
            <div class="address tw-mt-2 tw-flex tw-items-center tw-gap-1">
              <p class="tw-capitalize">{{ property.display_address }}</p>
            </div>
            <div v-if="!property.is_locked" class="tw-mt-3 tw-flex tw-items-center tw-gap-1">
              <div class="rooms tw-flex tw-flex-row tw-items-center tw-gap-4">
                <p>{{ property.bedroom }} BED</p>
                <p>{{ property.bathroom }} BATH</p>
                <p>{{ property.reception }} REC</p>
              </div>
            </div>
            <div class="tw-flex tw-flex-col tw-items-start tw-gap-5 tw-py-5 md:tw-flex-row md:tw-items-center">
              <button v-if="!property.is_locked" class="n-primary" @click="onSendLead()">BOOK A VIEWING</button>
              <!-- <button @click="href('cinematic_videography')" class="n-secondary">CINEMATIC VIDEOGRAPHY</button> -->
              <div
                class="tw-flex tw-h-12 tw-w-12 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full"
                style="background-color: transparent; border: 1px solid var(--c-primary)"
                @click="onShared()"
              >
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.5386 3C19.9534 2.9998 19.3753 3.12802 18.845 3.37562C18.3147 3.62321 17.8452 3.98414 17.4697 4.43296C17.0941 4.88177 16.8216 5.40752 16.6713 5.97314C16.5211 6.53875 16.4968 7.13044 16.6002 7.70646L10.7786 11.7828C10.7495 11.8029 10.7216 11.8247 10.6949 11.848C10.1043 11.3863 9.39588 11.0999 8.65036 11.0214C7.90484 10.9429 7.15226 11.0754 6.47844 11.404C5.80462 11.7325 5.23669 12.2438 4.83939 12.8795C4.4421 13.5152 4.23145 14.2497 4.23145 14.9994C4.23145 15.749 4.4421 16.4836 4.83939 17.1193C5.23669 17.755 5.80462 18.2663 6.47844 18.5948C7.15226 18.9233 7.90484 19.0559 8.65036 18.9774C9.39588 18.8989 10.1043 18.6125 10.6949 18.1508C10.7215 18.1745 10.7495 18.1967 10.7786 18.2172L16.6002 22.2935C16.4273 23.2569 16.6137 24.2502 17.1241 25.0854C17.6344 25.9206 18.4333 26.5397 19.3694 26.8255C20.3055 27.1113 21.3139 27.0439 22.2037 26.6362C23.0935 26.2284 23.8029 25.5086 24.1976 24.613C24.5923 23.7173 24.645 22.708 24.3456 21.7762C24.0461 20.8443 23.4155 20.0546 22.5729 19.5565C21.7304 19.0584 20.7344 18.8865 19.7737 19.0734C18.8129 19.2603 17.954 19.7929 17.3595 20.5705L11.8469 16.712C12.0931 16.1926 12.2309 15.6129 12.2309 15C12.2309 14.3871 12.0931 13.8062 11.8469 13.288L17.3608 9.42831C17.7738 9.96895 18.3179 10.3953 18.9416 10.6671C19.5654 10.9388 20.2481 11.047 20.9253 10.9813C21.6024 10.9157 22.2517 10.6784 22.8116 10.2919C23.3715 9.90545 23.8236 9.38253 24.1251 8.77263C24.4266 8.16273 24.5676 7.48601 24.5347 6.80646C24.5017 6.1269 24.296 5.46697 23.937 4.88907C23.5779 4.31117 23.0774 3.8344 22.4828 3.50385C21.8881 3.17329 21.219 2.99988 20.5386 3ZM18.3848 7C18.3848 6.42876 18.6117 5.88093 19.0156 5.477C19.4195 5.07308 19.9674 4.84615 20.5386 4.84615C21.1099 4.84615 21.6577 5.07308 22.0616 5.477C22.4655 5.88093 22.6925 6.42876 22.6925 7C22.6925 7.57124 22.4655 8.11907 22.0616 8.523C21.6577 8.92692 21.1099 9.15385 20.5386 9.15385C19.9674 9.15385 19.4195 8.92692 19.0156 8.523C18.6117 8.11907 18.3848 7.57124 18.3848 7ZM8.23093 12.8462C7.6597 12.8462 7.11186 13.0731 6.70793 13.477C6.30401 13.8809 6.07709 14.4288 6.07709 15C6.07709 15.5712 6.30401 16.1191 6.70793 16.523C7.11186 16.9269 7.6597 17.1538 8.23093 17.1538C8.80217 17.1538 9.35001 16.9269 9.75393 16.523C10.1579 16.1191 10.3848 15.5712 10.3848 15C10.3848 14.4288 10.1579 13.8809 9.75393 13.477C9.35001 13.0731 8.80217 12.8462 8.23093 12.8462ZM20.5386 20.8462C19.9674 20.8462 19.4195 21.0731 19.0156 21.477C18.6117 21.8809 18.3848 22.4288 18.3848 23C18.3848 23.5712 18.6117 24.1191 19.0156 24.523C19.4195 24.9269 19.9674 25.1538 20.5386 25.1538C21.1099 25.1538 21.6577 24.9269 22.0616 24.523C22.4655 24.1191 22.6925 23.5712 22.6925 23C22.6925 22.4288 22.4655 21.8809 22.0616 21.477C21.6577 21.0731 21.1099 20.8462 20.5386 20.8462Z"
                    fill="var(--c-primary)"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div
            class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between lg:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8"
          >
            <div
              class="tw-flex tw-w-full tw-items-center tw-justify-between max-lg:tw-pt-4 lg:tw-justify-end lg:tw-gap-8"
            >
              <div v-if="property.price">
                <p v-if="property.price.type.name" class="tw-font-bold tw-uppercase">
                  {{ property.price.type.name }}
                </p>
                <h5 class="!tw-text-3xl">{{ property.price.price }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- variant v1 for gallery -->
      <template v-if="vars.galleryVersionText === 'v1'">
        <div v-if="featuredVideo" class="tw-w-screen tw-px-4 tw-py-5">
          <div v-if="!isMobileDevice" class="tw-grid tw-grid-cols-[2.25fr_6.5fr_3.25fr] tw-gap-5">
            <div class="tw-relative">
              <div class="tw-aspect-[9/16] tw-h-full tw-w-full">
                <library-iframe
                  class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
                  :src="featuredVideo"
                  frameborder="0"
                  allowfullscreen
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                ></library-iframe>
              </div>
            </div>

            <div>
              <library-image
                v-if="primaryFivePhotos[0].background"
                :src="primaryFivePhotos[0].background"
                image-class="tw-h-full tw-cursor-pointer"
                alt="property first image"
                :title="property.advert_heading"
                @click="onClickedImage(primaryFivePhotos[0])"
                :design-width="998"
                :design-height="659"
                :style="`border-radius: var(--rounded);`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              >
                <template #overlay-item>
                  <div class="nc-first-image-overlay-item">
                    <div
                      v-if="property && property.medias"
                      style="
                        border-radius: var(--rounded-sm);
                        color: var(--c-text-primary);
                        background-color: var(--c-section_primary);
                      "
                      class="tw-text-md tw-px-2 tw-py-1"
                    >
                      1/{{ property.medias.length }}
                    </div>
                  </div>
                </template>
              </library-image>
            </div>

            <div class="tw-flex tw-flex-col tw-justify-between">
              <library-image
                v-if="primaryFivePhotos[1].background"
                :src="primaryFivePhotos[1].background"
                alt="property first image"
                image-class="tw-cursor-pointer"
                @click="onClickedImage(primaryFivePhotos[1])"
                :title="property.advert_heading"
                :design-width="472"
                :design-height="319"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />

              <library-image
                v-if="primaryFivePhotos[2].background"
                :src="primaryFivePhotos[2].background"
                alt="property first image"
                image-class="tw-cursor-pointer"
                @click="onClickedImage(primaryFivePhotos[2])"
                :title="property.advert_heading"
                :design-width="472"
                :design-height="319"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              >
                <template #overlay-item>
                  <div
                    v-if="property && property.medias"
                    class="tw-absolute tw-inset-0 tw-z-10 tw-h-full tw-w-full tw-bg-black tw-opacity-30"
                    style="border-radius: var(--rounded-sm)"
                  ></div>
                  <button
                    class="tw-z-20 tw-px-4 tw-py-2"
                    style="background-color: var(--c-input); color: var(--c-text-secondary)"
                  >
                    SEE ALL PHOTOS
                  </button>
                </template>
              </library-image>
            </div>
          </div>
          <div v-else-if="isMobileDevice">
            <div class="tw-relative tw-pb-4">
              <div class="tw-aspect-[9/16] tw-h-full tw-w-full">
                <library-iframe
                  class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
                  :src="property.featured_video?.mediaLink"
                  style="border-radius: var(--rounded)"
                  :w-ratio="9"
                  :h-ratio="16"
                  frameborder="0"
                  allowfullscreen
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                ></library-iframe>
              </div>
            </div>
            <Swiper
              :modules="[SwiperNavigation]"
              :pagination="true"
              :slides-per-view="1"
              :space-between="1"
              effect="fade"
              :clickable="true"
              :loop="true"
              :navigation="{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              }"
              class="tw-mt-6 tw-w-full"
              @swiper="onSwiper"
            >
              <SwiperSlide v-for="(item, index) in primaryFivePhotos" :key="index" class="tw-w-full">
                <library-image
                  :src="item.background"
                  @click="onClickedImage(item)"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
              </SwiperSlide>
              <div class="tw-flex tw-items-center tw-justify-between">
                <div class="swiper-button-prev tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3">
                  <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18.75 7.5H5.25C4.83 7.5 4.5 7.17 4.5 6.75C4.5 6.33 4.83 6 5.25 6H18.75C19.17 6 19.5 6.33 19.5 6.75C19.5 7.17 19.17 7.5 18.75 7.5Z"
                      fill="black"
                    />
                    <path
                      d="M9 12.75C8.90164 12.7512 8.80411 12.7318 8.71369 12.6931C8.62328 12.6543 8.54197 12.5971 8.475 12.525L3.225 7.275C2.925 6.975 2.925 6.51 3.225 6.21L8.475 0.975C8.775 0.675 9.24 0.675 9.54 0.975C9.84 1.275 9.84 1.74 9.54 2.04L4.815 6.765L9.54 11.49C9.84 11.79 9.84 12.255 9.54 12.555C9.39 12.705 9.195 12.78 9.015 12.78L9 12.75Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div class="swiper-button-next tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3">
                  <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M5.25 7.5H18.75C19.17 7.5 19.5 7.17 19.5 6.75C19.5 6.33 19.17 6 18.75 6H5.25C4.83 6 4.5 6.33 4.5 6.75C4.5 7.17 4.83 7.5 5.25 7.5Z"
                      fill="black"
                    />
                    <path
                      d="M15 12.75C15.0984 12.7512 15.1959 12.7318 15.2863 12.6931C15.3767 12.6543 15.458 12.5971 15.525 12.525L20.775 7.275C21.075 6.975 21.075 6.51 20.775 6.21L15.525 0.975C15.225 0.675 14.76 0.675 14.46 0.975C14.16 1.275 14.16 1.74 14.46 2.04L19.185 6.765L14.46 11.49C14.16 11.79 14.16 12.255 14.46 12.555C14.61 12.705 14.805 12.78 14.985 12.78L15 12.75Z"
                      fill="black"
                    />
                  </svg>
                </div>
              </div>
            </Swiper>
          </div>
        </div>
        <div v-else class="tw-w-screen tw-px-4">
          <div class="tw-mt-16 tw-w-full" :class="!isMobileDevice ? 'tw-grid tw-grid-cols-12 tw-gap-x-3' : ''">
            <div
              v-if="!isMobileDevice"
              class="property-detail-image-container tw-col-span-12 tw-h-full tw-w-full lg:tw-col-span-6"
              @click="onClickedImage(null)"
            >
              <library-image
                :src="primarySevenPhotos[0].background"
                image-class="tw-h-full tw-cursor-pointer"
                alt="property first image"
                :title="property.advert_heading"
                @click="onClickedImage(primarySevenPhotos[0])"
                :design-width="948"
                :design-height="626"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />
            </div>

            <div
              v-if="!isMobileDevice"
              class="tw-col-span-12 tw-grid tw-h-full tw-grid-cols-12 tw-gap-x-3 md:tw-col-span-6"
            >
              <div class="tw-col-span-6 tw-flex tw-flex-row tw-gap-y-3 md:tw-flex-col">
                <library-image
                  :src="primarySevenPhotos[1].background"
                  alt="property first image"
                  image-class="tw-cursor-pointer"
                  @click="onClickedImage(primarySevenPhotos[1])"
                  :title="property.advert_heading"
                  :design-width="448"
                  :design-height="303"
                  :style="`border-radius: var(--rounded)`"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />

                <library-image
                  :src="primarySevenPhotos[2].background"
                  alt="property second image"
                  image-class="tw-cursor-pointer"
                  @click="onClickedImage(primarySevenPhotos[2])"
                  :title="property.advert_heading"
                  :design-width="448"
                  :design-height="303"
                  :style="`border-radius: var(--rounded)`"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
              </div>
              <div class="tw-col-span-6 tw-flex tw-flex-row tw-gap-y-3 md:tw-flex-col">
                <library-image
                  :src="primarySevenPhotos[3].background"
                  image-class="tw-cursor-pointer"
                  @click="onClickedImage(primarySevenPhotos[4])"
                  :design-width="448"
                  :design-height="303"
                  :style="`border-radius: var(--rounded)`"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />

                <library-image
                  :src="primarySevenPhotos[4].background"
                  alt="property second image"
                  image-class="tw-cursor-pointer"
                  @click="onClickedImage(primarySevenPhotos[6])"
                  :title="property.advert_heading"
                  :design-width="448"
                  :design-height="303"
                  :style="`border-radius: var(--rounded)`"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                >
                  <template #overlay-item>
                    <div
                      v-if="property && property.medias"
                      class="tw-absolute tw-inset-0 tw-z-10 tw-h-full tw-w-full tw-bg-black tw-opacity-30"
                      style="border-radius: var(--rounded-sm)"
                    ></div>
                    <button
                      class="tw-z-20 tw-px-4 tw-py-2"
                      style="background-color: var(--c-section_primary); color: var(--c-text-primary)"
                    >
                      SEE ALL PHOTOS
                    </button>
                  </template>
                </library-image>
              </div>
            </div>
            <div v-else-if="isMobileDevice" class="n-main-container tw-w-screen">
              <Swiper
                :modules="[SwiperNavigation]"
                :pagination="true"
                :loop="true"
                :slides-per-view="1"
                :space-between="1"
                effect="fade"
                :clickable="true"
                :navigation="{
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }"
                class="tw-w-full"
                @swiper="onSwiper"
              >
                <SwiperSlide v-for="(item, index) in primaryFivePhotos" :key="index" class="tw-w-full">
                  <library-image
                    :src="item.background"
                    @click="onClickedImage(item)"
                    :blur="imageBlurFilter"
                    :pre-market-blur-text="preMarketBlurText"
                  />
                </SwiperSlide>
                <div class="tw-flex tw-items-center tw-justify-between">
                  <div
                    class="swiper-button-prev tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3"
                  >
                    <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M18.75 7.5H5.25C4.83 7.5 4.5 7.17 4.5 6.75C4.5 6.33 4.83 6 5.25 6H18.75C19.17 6 19.5 6.33 19.5 6.75C19.5 7.17 19.17 7.5 18.75 7.5Z"
                        fill="black"
                      />
                      <path
                        d="M9 12.75C8.90164 12.7512 8.80411 12.7318 8.71369 12.6931C8.62328 12.6543 8.54197 12.5971 8.475 12.525L3.225 7.275C2.925 6.975 2.925 6.51 3.225 6.21L8.475 0.975C8.775 0.675 9.24 0.675 9.54 0.975C9.84 1.275 9.84 1.74 9.54 2.04L4.815 6.765L9.54 11.49C9.84 11.79 9.84 12.255 9.54 12.555C9.39 12.705 9.195 12.78 9.015 12.78L9 12.75Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                  <div
                    class="swiper-button-next tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3"
                  >
                    <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.25 7.5H18.75C19.17 7.5 19.5 7.17 19.5 6.75C19.5 6.33 19.17 6 18.75 6H5.25C4.83 6 4.5 6.33 4.5 6.75C4.5 7.17 4.83 7.5 5.25 7.5Z"
                        fill="black"
                      />
                      <path
                        d="M15 12.75C15.0984 12.7512 15.1959 12.7318 15.2863 12.6931C15.3767 12.6543 15.458 12.5971 15.525 12.525L20.775 7.275C21.075 6.975 21.075 6.51 20.775 6.21L15.525 0.975C15.225 0.675 14.76 0.675 14.46 0.975C14.16 1.275 14.16 1.74 14.46 2.04L19.185 6.765L14.46 11.49C14.16 11.79 14.16 12.255 14.46 12.555C14.61 12.705 14.805 12.78 14.985 12.78L15 12.75Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                </div>
              </Swiper>
            </div>
          </div>
        </div>
      </template>
      <!-- tabs -->
      <template v-if="!property.is_locked">
        <ul
          v-if="variant === variants.v1"
          class="nav nav-tabs pxp-nav-tabs tw-my-8 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-10 lg:tw-flex-row"
        >
          <li v-for="(tab, tabIndex) in tabs" :key="`tab-${tabIndex}`" class="nav-item">
            <div
              :class="activeTab.name === tab.name ? 'active' : ''"
              class="nav-link tw-cursor-pointer tw-font-bold"
              data-toggle="tab"
              @click="
                () => {
                  activeTab.name = tab.name;
                  activeTab.title = tab.title;
                }
              "
            >
              {{ tab.title }}
            </div>
          </li>
        </ul>
      </template>
      <template v-else-if="property.is_locked">
        <library-login />
      </template>
      <ul
        class="nav nav-tabs pxp-nav-tabs sticky-nav tw-my-8 tw-flex tw-min-h-16 tw-w-full tw-flex-wrap tw-items-center tw-justify-center tw-gap-2 tw-pb-2 tw-pt-4 tw-transition-all tw-duration-200 min-[480px]:tw-text-center md:tw-gap-4 lg:tw-flex-nowrap lg:tw-gap-5"
        :class="isScrolled ? 'tw-fixed tw-top-14 tw-z-30 tw-bg-white' : ''"
        v-if="variant === variants.v2 && !property.is_locked"
        ref="navTabs"
      >
        <li
          v-for="(tab, tabIndex) in tabsV2"
          :key="`tab2-${tabIndex}`"
          class="nav-item tw-flex-[40%] min-[480px]:tw-flex-[30%] sm:tw-flex-auto"
        >
          <div
            :class="activeTabV2.name === tab.name ? 'active' : ''"
            class="nav-link tw-cursor-pointer tw-font-bold"
            data-toggle="tab"
            @click="
              () => {
                activeTabV2.name = tab.name;
              }
            "
          >
            <nuxt-link :to="`#${tab.name}`" class="!tw-p-2">{{ tab.title }}</nuxt-link>
          </div>
        </li>
      </ul>

      <!-- V3 Tabs -->
      <div
        v-if="variant === variants.v3 && !property.is_locked"
        class="tw-relative tw-bottom-5 tw-z-50 tw-w-full tw-text-center"
        style="border-radius: var(--rounded)"
      >
        <ul class="v3-tabs tw-overflow-x-scroll tw-shadow-md" role="tablist">
          <li
            v-for="(tab, i) in tabsV3"
            :key="`tab3-${i}`"
            class="v3-tab"
            :class="{ 'is-active': activeTabV3.name === tab.name }"
            role="tab"
            @click="
              () => {
                activeTabV3.name = tab.name;
                activeTabV3.title = tab.title;
              }
            "
          >
            {{ tab.title }}
          </li>
        </ul>
      </div>

      <!-- tabs end -->
    </section>

    <!-- PROPERTY DETAIL (v1) -->
    <section
      v-if="variant === variants.v1 && !property.is_locked"
      class="n-section-primary !tw-pt-0"
      style="background-color: var(--c-section_primary)"
    >
      <div>
        <div class="tw-grid tw-grid-cols-12 md:tw-gap-x-10">
          <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8">
            <div class="tab-content tw-mt-6">
              <div v-show="activeTab.name === 'features'">
                <h4 class="tw-pb-4">{{ activeTab.title }}</h4>
                <div v-if="property?.features" class="tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-4">
                  <div
                    v-for="(feature, index) in property.features"
                    :key="`property-feature-${index}`"
                    class="tw-col-span-12 tw-flex tw-items-start tw-gap-x-3 md:tw-col-span-6 xl:tw-col-span-4"
                  >
                    <span>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                          fill="var(--c-tertiary)"
                        />
                      </svg>
                    </span>
                    <library-text class="tw-text-sm tw-font-semibold tw-uppercase" :text="feature"> </library-text>
                  </div>
                </div>
              </div>

              <div v-show="activeTab.name === 'property_information'" id="property_information" role="tabpanel">
                <h4 class="tw-pb-4">{{ activeTab.title }}</h4>

                <library-text class="tw-text-sm" :html="property.description"></library-text>

                <!-- amenties -->
                <library-properties-property-criteria-list
                  :property="property"
                  class="tw-mt-8"
                  main-list-title="Additional Information"
                  additional-list-title=""
                >
                  <template #list-item="{ criteria }">
                    <div class="tw-col-span-12 md:tw-col-span-6" style="">
                      <div class="tw-grid tw-grid-cols-2">
                        <p class="tw-col-span-1">{{ criteria.title }}:</p>
                        <p class="tw-col-span-1 tw-text-left !tw-font-bold tw-capitalize">&nbsp;{{ criteria.value }}</p>
                      </div>
                    </div>
                  </template>
                </library-properties-property-criteria-list>
              </div>

              <div v-show="activeTab.name === 'matterport_video'" id="matterport_video" role="tabpanel" class="tw-pb-8">
                <div v-if="property?.virtual_tour">
                  <h4 class="tw-pb-4">{{ activeTab.title }}</h4>
                  <library-iframe :src="matterPort" :blur="imageBlurFilter" :pre-market-blur-text="preMarketBlurText" />
                </div>
              </div>

              <div v-show="activeTab.name === 'video_tour'" id="video_tour" role="tabpanel">
                <div v-if="featuredVideo">
                  <h4 class="tw-pb-4">{{ activeTab.title }}</h4>
                  <div class="tw-aspect-[9/16] tw-max-w-[420px]">
                    <library-iframe
                      class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
                      :src="featuredVideo"
                      frameborder="0"
                      allowfullscreen
                      :blur="imageBlurFilter"
                      :pre-market-blur-text="preMarketBlurText"
                    ></library-iframe>
                  </div>
                </div>
              </div>

              <div v-show="activeTab.name === 'floor_plan'" id="floor_plan" role="tabpanel">
                <h4 class="tw-pb-4">{{ activeTab.title }}</h4>

                <floor-plan :data="property.floor_plans" :component="component" />
              </div>
              <div v-show="activeTab.name === 'map'" id="map" role="tabpanel">
                <h4 class="tw-pb-4">{{ activeTab.title }}</h4>

                <neuron-google-map
                  v-if="property.map_position && property.map_position.lat && property.map_position.lng"
                  v-model:map-center-position="property.map_position"
                  :component="component"
                  :marker-color="markerColor"
                />
              </div>
              <div v-show="activeTab.name === 'epc'" id="epc" role="tabpanel">
                <h4 class="tw-pb-4">{{ activeTab.title }}</h4>
                <epc :data="property.epcs" :component="component" />
              </div>
            </div>
          </div>
          <div class="tw-col-span-12 tw-pt-6 lg:tw-col-span-5 xl:tw-col-span-4">
            <div v-if="sidebarComponents && sidebarComponents.length" class="tw-flex tw-flex-col tw-gap-4">
              <div v-if="vars.viewingOptionsBool">
                <div
                  class="tw-relative tw-flex tw-w-full tw-flex-col tw-justify-center tw-gap-5 tw-px-4 tw-py-9 tw-text-start"
                  :style="`background-color: var(--c-sidebar-card); border-radius: var(--rounded);`"
                >
                  <h4>{{ vars.viewingOptionsTitleText }}</h4>
                  <p v-if="vars.viewingOptionsDescriptionText">
                    {{ vars.viewingOptionsDescriptionText }}
                  </p>
                  <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-4">
                    <button
                      v-if="featuredVideo"
                      :class="`n-${vars.viewingOptionsButton1TypeText} tw-w-fit`"
                      @click="onVidePopup()"
                    >
                      {{ vars.viewingOptionsButton1LabelText }}
                    </button>
                    <button :class="`n-${vars.viewingOptionsButton2TypeText} tw-w-fit`" @click="onSendLead()">
                      {{ vars.viewingOptionsButton2LabelText }}
                    </button>
                  </div>
                </div>
              </div>
              <theme6-available-components-for-sidebar
                key="property-detail-sidebar"
                key-prefix="property-detail-sidebar"
                :specific-components="sidebarComponents"
              />
            </div>
          </div>
        </div>
      </div>

      <full-screen-gallery
        v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
        v-model:active-media-index="activeMediaIndex"
        :component="component"
        :active-media="activeMedia"
        :count-of-medias="property.medias.length"
        @close="closeLightbox()"
      />

      <popup :config="sendLeadPopupConfig" custom-width="800px">
        <template #content>
          <send-lead
            v-if="sendLeadPopupConfig.isActive"
            :property="property"
            @on-success="onSuccess"
            @close="sendLeadPopupConfig.isActive = false"
          />
        </template>
      </popup>

      <popup :config="videoPopupConfig" v-if="videoPopupConfig.videoPopupSrc" custom-width="500px" @close="stopVideo">
        <template #content>
          <div class="tw-relative tw-pt-6">
            <div class="tw-aspect-[9/16] tw-h-full tw-w-full">
              <library-iframe
                class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
                :src="videoPopupConfig.videoPopupSrc"
                frameborder="0"
                allowfullscreen
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              ></library-iframe>
            </div>
          </div>
        </template>
      </popup>

      <popup :config="successModalConfig" @close="onSuccessModalClosed()">
        <template #content>
          <success :text="successPopupText" />
        </template>
      </popup>
    </section>

    <!-- PROPERTY DETAIL (v2) -->
    <section
      v-if="variant === variants.v2 && !property.is_locked"
      class="n-section-primary !tw-pt-0"
      style="background-color: var(--c-section_primary)"
    >
      <div>
        <div class="tw-grid tw-grid-cols-12 md:tw-gap-x-10">
          <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8">
            <div class="tab-content tw-mt-6">
              <div id="cinematic_videography" role="tabpanel" class="tw-pb-8">
                <div v-if="featuredVideo">
                  <h4 class="tw-pb-4">CINEMATIC VIDEOGRAPHY</h4>

                  <library-iframe
                    :src="featuredVideo"
                    :blur="imageBlurFilter"
                    :pre-market-blur-text="preMarketBlurText"
                  />
                </div>
              </div>

              <div id="features" role="tabpanel" class="tw-pb-8">
                <h4 class="tw-pb-4">FEATURES</h4>

                <div v-if="property?.features" class="tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-4">
                  <div
                    v-for="(feature, index) in property.features"
                    :key="`property-feature-${index}`"
                    class="tw-col-span-12 tw-flex tw-items-start tw-gap-x-3 md:tw-col-span-6 xl:tw-col-span-4"
                  >
                    <span>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                          fill="var(--c-primary)"
                        />
                      </svg>
                    </span>
                    <library-text class="tw-text-sm tw-font-semibold tw-uppercase" :text="feature"> </library-text>
                  </div>
                </div>
              </div>
              <div id="property_information" role="tabpanel" class="tw-pb-8">
                <h4 class="tw-pb-4">PROPERTY INFO</h4>

                <library-text class="tw-text-sm" :html="property.description"></library-text>

                <!-- amenties -->
                <div v-if="property?.criteria_list" class="tw-grid tw-grid-cols-12 tw-gap-4 tw-pt-6">
                  <div
                    v-for="(criteria, index) in property?.criteria_list"
                    :key="`criteria-${index}`"
                    class="tw-col-span-12 md:tw-col-span-6"
                  >
                    <div class="tw-grid tw-grid-cols-2">
                      <p class="tw-col-span-1">{{ criteria.title }}:</p>
                      <p class="tw-col-span-1 tw-text-left !tw-font-bold tw-capitalize">&nbsp;{{ criteria.value }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!--               <div id="matterport_video" role="tabpanel" class="tw-pb-8">
                <div v-if="property?.virtual_tour">
                  <h4 class="tw-pb-4">MATTERPORT VIDEO</h4>
                  <library-iframe :src="matterPort" />
                </div>
              </div> -->

              <div id="floor_plan" role="tabpanel" class="tw-pb-8">
                <h4 class="tw-pb-4">FLOOR PLANS</h4>

                <floor-plan :data="property.floor_plans" :component="component" />
              </div>
              <div id="map" role="tabpanel" class="tw-pb-8">
                <h4 class="tw-pb-4">MAP</h4>

                <neuron-google-map
                  v-if="property.map_position && property.map_position.lat && property.map_position.lng"
                  v-model:map-center-position="property.map_position"
                  :component="component"
                  :marker-color="markerColor"
                />
              </div>
              <div v-if="property?.epcs?.length" id="epc" role="tabpanel" class="tw-pb-8">
                <h4 class="tw-pb-4">EPC</h4>
                <epc :data="property.epcs" :component="component" />
              </div>
            </div>
          </div>
          <!-- Property Video, Send Lead: START -->
          <div class="tw-col-span-12 tw-pt-6 lg:tw-col-span-5 xl:tw-col-span-4">
            <div v-if="sidebarComponents && sidebarComponents.length" class="tw-flex tw-flex-col tw-gap-4">
              <div v-if="vars.viewingOptionsBool">
                <div
                  class="tw-relative tw-flex tw-w-full tw-flex-col tw-justify-center tw-gap-5 tw-px-4 tw-py-9 tw-text-start"
                  :style="`background-color: var(--c-sidebar-card); border-radius: var(--rounded);`"
                >
                  <h4>{{ vars.viewingOptionsTitleText }}</h4>
                  <p v-if="vars.viewingOptionsDescriptionText">
                    {{ vars.viewingOptionsDescriptionText }}
                  </p>
                  <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-4">
                    <button :class="`n-${vars.viewingOptionsButton1TypeText} tw-w-fit`" @click="onVidePopup()">
                      {{ vars.viewingOptionsButton1LabelText }}
                    </button>
                    <button :class="`n-${vars.viewingOptionsButton2TypeText} tw-w-fit`" @click="onSendLead()">
                      {{ vars.viewingOptionsButton2LabelText }}
                    </button>
                  </div>
                </div>
              </div>
              <theme6-available-components-for-sidebar
                key="property-detail-sidebar"
                key-prefix="property-detail-sidebar"
                :specific-components="sidebarComponents"
              />
            </div>
          </div>
        </div>
      </div>

      <full-screen-gallery
        v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
        v-model:active-media-index="activeMediaIndex"
        :component="component"
        :active-media="activeMedia"
        :count-of-medias="property.medias.length"
        @close="closeLightbox()"
      />

      <popup :config="videoPopupConfig" custom-width="800px" @close="stopVideo">
        <template #content>
          <div class="tw-relative tw-pt-6">
            <library-iframe
              :src="videoPopupConfig.videoPopupSrc"
              frameborder="0"
              allowfullscreen
              :blur="imageBlurFilter"
              :pre-market-blur-text="preMarketBlurText"
            ></library-iframe>
          </div>
        </template>
      </popup>

      <popup :config="sendLeadPopupConfig" custom-width="800px">
        <template #content>
          <send-lead
            v-if="sendLeadPopupConfig.isActive"
            :property="property"
            @on-success="onSuccess"
            @close="sendLeadPopupConfig.isActive = false"
          />
        </template>
      </popup>
      <popup :config="successModalConfig" @close="onSuccessModalClosed()">
        <template #content>
          <success :text="successPopupText" />
        </template>
      </popup>
    </section>

    <!-- PROPERTY DETAIL (v3)  -->
    <section
      v-if="variant === variants.v3 && !property.is_locked"
      class="n-section-primary !tw-pt-0"
      style="background-color: var(--c-section_primary)"
    >
      <div class="tw-w-full">
        <div class="tw-grid tw-grid-cols-12 md:tw-gap-x-10">
          <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8">
            <div class="tab-content tw-mt-6">
              <!-- CINEMATIC VIDEO -->
              <div v-if="activeTabV3.name === 'cinematic_videography' && featuredVideo" class="tw-pb-8">
                <h2 class="tw-pb-4">CINEMATIC VIDEOGRAPHY</h2>
                <library-iframe
                  :src="featuredVideo"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
              </div>

              <!-- FEATURES -->
              <div v-if="activeTabV3.name === 'features'" class="tw-pb-8">
                <h2 class="tw-pb-4">FEATURES</h2>
                <div v-if="property?.features" class="tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-4">
                  <div
                    v-for="(feature, index) in property.features"
                    :key="`property-feature-v3-${index}`"
                    class="tw-col-span-12 tw-flex tw-items-start tw-gap-x-3 md:tw-col-span-6 xl:tw-col-span-4"
                  >
                    <span>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                          fill="var(--c-primary)"
                        />
                      </svg>
                    </span>
                    <library-text class="tw-text-sm tw-font-semibold tw-uppercase" :text="feature" />
                  </div>
                </div>
              </div>

              <!-- PROPERTY INFO -->
              <div v-if="activeTabV3.name === 'property_information'" class="tw-pb-8">
                <h2 class="tw-pb-4">PROPERTY INFO</h2>
                <div
                  v-if="property?.criteria_list"
                  class="tw-mt-4 tw-flex tw-flex-col tw-gap-4 md:tw-mt-8 md:tw-flex-row md:tw-flex-wrap md:tw-gap-6"
                >
                  <div
                    v-for="criteria in property.criteria_list"
                    :key="criteria.id"
                    class="tw-flex tw-gap-4 tw-py-2 md:tw-p-4"
                    style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                  >
                    <span v-if="criteria.title === 'Parking'">
                      <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M45 21.5955H42.7312L37.4231 9.65358C37.2168 9.18982 36.8805 8.79581 36.4549 8.51927C36.0293 8.24273 35.5326 8.09552 35.025 8.09546H12.975C12.4674 8.09552 11.9707 8.24273 11.5451 8.51927C11.1195 8.79581 10.7832 9.18982 10.5769 9.65358L5.26875 21.5955H3C2.70163 21.5955 2.41548 21.714 2.2045 21.925C1.99353 22.1359 1.875 22.4221 1.875 22.7205C1.875 23.0188 1.99353 23.305 2.2045 23.516C2.41548 23.7269 2.70163 23.8455 3 23.8455H4.875V39.2205C4.875 39.9167 5.15156 40.5843 5.64384 41.0766C6.13613 41.5689 6.80381 41.8455 7.5 41.8455H12C12.6962 41.8455 13.3639 41.5689 13.8562 41.0766C14.3484 40.5843 14.625 39.9167 14.625 39.2205V35.8455H33.375V39.2205C33.375 39.9167 33.6516 40.5843 34.1438 41.0766C34.6361 41.5689 35.3038 41.8455 36 41.8455H40.5C41.1962 41.8455 41.8639 41.5689 42.3562 41.0766C42.8484 40.5843 43.125 39.9167 43.125 39.2205V23.8455H45C45.2984 23.8455 45.5845 23.7269 45.7955 23.516C46.0065 23.305 46.125 23.0188 46.125 22.7205C46.125 22.4221 46.0065 22.1359 45.7955 21.925C45.5845 21.714 45.2984 21.5955 45 21.5955ZM12.6319 10.5686C12.6613 10.5021 12.7094 10.4457 12.7703 10.4061C12.8312 10.3665 12.9023 10.3454 12.975 10.3455H35.025C35.0977 10.3454 35.1688 10.3665 35.2297 10.4061C35.2906 10.4457 35.3387 10.5021 35.3681 10.5686L40.2694 21.5955H7.73063L12.6319 10.5686ZM12.375 39.2205C12.375 39.3199 12.3355 39.4153 12.2652 39.4856C12.1948 39.556 12.0995 39.5955 12 39.5955H7.5C7.40054 39.5955 7.30516 39.556 7.23483 39.4856C7.16451 39.4153 7.125 39.3199 7.125 39.2205V35.8455H12.375V39.2205ZM40.5 39.5955H36C35.9005 39.5955 35.8052 39.556 35.7348 39.4856C35.6645 39.4153 35.625 39.3199 35.625 39.2205V35.8455H40.875V39.2205C40.875 39.3199 40.8355 39.4153 40.7652 39.4856C40.6948 39.556 40.5995 39.5955 40.5 39.5955ZM40.875 33.5955H7.125V23.8455H40.875V33.5955ZM10.875 28.7205C10.875 28.4221 10.9935 28.1359 11.2045 27.925C11.4155 27.714 11.7016 27.5955 12 27.5955H15C15.2984 27.5955 15.5845 27.714 15.7955 27.925C16.0065 28.1359 16.125 28.4221 16.125 28.7205C16.125 29.0188 16.0065 29.305 15.7955 29.516C15.5845 29.7269 15.2984 29.8455 15 29.8455H12C11.7016 29.8455 11.4155 29.7269 11.2045 29.516C10.9935 29.305 10.875 29.0188 10.875 28.7205ZM31.875 28.7205C31.875 28.4221 31.9935 28.1359 32.2045 27.925C32.4155 27.714 32.7016 27.5955 33 27.5955H36C36.2984 27.5955 36.5845 27.714 36.7955 27.925C37.0065 28.1359 37.125 28.4221 37.125 28.7205C37.125 29.0188 37.0065 29.305 36.7955 29.516C36.5845 29.7269 36.2984 29.8455 36 29.8455H33C32.7016 29.8455 32.4155 29.7269 32.2045 29.516C31.9935 29.305 31.875 29.0188 31.875 28.7205Z"
                          fill="var(--c-primary)"
                        />
                      </svg>
                    </span>

                    <span v-else-if="criteria.title === 'Sewerage'">
                      <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M43.5 20.0955H38.625V10.3455H43.5C43.7984 10.3455 44.0845 10.2269 44.2955 10.016C44.5065 9.80498 44.625 9.51883 44.625 9.22046C44.625 8.92209 44.5065 8.63594 44.2955 8.42496C44.0845 8.21399 43.7984 8.09546 43.5 8.09546H38.3681C38.1555 7.6472 37.8202 7.26837 37.4011 7.00289C36.9819 6.7374 36.4961 6.59614 36 6.59546H33C32.5039 6.59614 32.0181 6.7374 31.5989 7.00289C31.1798 7.26837 30.8445 7.6472 30.6319 8.09546H27C21.9296 8.10141 17.0685 10.1183 13.4832 13.7036C9.89782 17.289 7.88095 22.15 7.875 27.2205V30.8523C7.42674 31.065 7.04791 31.4003 6.78243 31.8194C6.51694 32.2385 6.37568 32.7243 6.375 33.2205V36.2205C6.37568 36.7166 6.51694 37.2024 6.78243 37.6215C7.04791 38.0406 7.42674 38.376 7.875 38.5886V43.7205C7.875 44.0188 7.99353 44.305 8.2045 44.516C8.41548 44.7269 8.70163 44.8455 9 44.8455C9.29837 44.8455 9.58452 44.7269 9.7955 44.516C10.0065 44.305 10.125 44.0188 10.125 43.7205V38.8455H19.875V43.7205C19.875 44.0188 19.9935 44.305 20.2045 44.516C20.4155 44.7269 20.7016 44.8455 21 44.8455C21.2984 44.8455 21.5845 44.7269 21.7955 44.516C22.0065 44.305 22.125 44.0188 22.125 43.7205V38.5886C22.5733 38.376 22.9521 38.0406 23.2176 37.6215C23.4831 37.2024 23.6243 36.7166 23.625 36.2205V33.2205C23.6243 32.7243 23.4831 32.2385 23.2176 31.8194C22.9521 31.4003 22.5733 31.065 22.125 30.8523V27.2205C22.125 25.9275 22.6386 24.6876 23.5529 23.7733C24.4671 22.8591 25.7071 22.3455 27 22.3455H30.6319C30.8445 22.7937 31.1798 23.1726 31.5989 23.438C32.0181 23.7035 32.5039 23.8448 33 23.8455H36C36.4961 23.8448 36.9819 23.7035 37.4011 23.438C37.8202 23.1726 38.1555 22.7937 38.3681 22.3455H43.5C43.7984 22.3455 44.0845 22.2269 44.2955 22.016C44.5065 21.805 44.625 21.5188 44.625 21.2205C44.625 20.9221 44.5065 20.6359 44.2955 20.425C44.0845 20.214 43.7984 20.0955 43.5 20.0955ZM21 32.8455C21.0995 32.8455 21.1948 32.885 21.2652 32.9553C21.3355 33.0256 21.375 33.121 21.375 33.2205V36.2205C21.375 36.3199 21.3355 36.4153 21.2652 36.4856C21.1948 36.556 21.0995 36.5955 21 36.5955H9C8.90054 36.5955 8.80516 36.556 8.73483 36.4856C8.66451 36.4153 8.625 36.3199 8.625 36.2205V33.2205C8.625 33.121 8.66451 33.0256 8.73483 32.9553C8.80516 32.885 8.90054 32.8455 9 32.8455H21ZM19.875 27.2205V30.5955H10.125V27.2205C10.13 22.7465 11.9095 18.4571 15.0731 15.2935C18.2367 12.1299 22.526 10.3504 27 10.3455H30.375V20.0955H27C25.1103 20.0955 23.2981 20.8461 21.9619 22.1823C20.6257 23.5185 19.875 25.3308 19.875 27.2205ZM36 21.5955H33C32.9005 21.5955 32.8052 21.556 32.7348 21.4856C32.6645 21.4153 32.625 21.3199 32.625 21.2205V9.22046C32.625 9.121 32.6645 9.02562 32.7348 8.95529C32.8052 8.88497 32.9005 8.84546 33 8.84546H36C36.0995 8.84546 36.1948 8.88497 36.2652 8.95529C36.3355 9.02562 36.375 9.121 36.375 9.22046V21.2205C36.375 21.3199 36.3355 21.4153 36.2652 21.4856C36.1948 21.556 36.0995 21.5955 36 21.5955Z"
                          fill="var(--c-primary)"
                        />
                      </svg>
                    </span>

                    <span v-else-if="criteria.title === 'Water'">
                      <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M5 34.6805V32.6045C6.036 32.4765 6.84267 32.1365 7.42 31.5845C7.99867 31.0338 9.092 30.7585 10.7 30.7585C12.3853 30.7585 13.5747 31.0918 14.268 31.7585C14.9613 32.4251 15.9847 32.7585 17.338 32.7585C18.7073 32.7585 19.7387 32.4251 20.432 31.7585C21.1253 31.0918 22.3147 30.7585 24 30.7585C25.6693 30.7585 26.8587 31.0918 27.568 31.7585C28.2773 32.4251 29.3087 32.7585 30.662 32.7585C32.0313 32.7585 33.0587 32.4251 33.744 31.7585C34.4307 31.0918 35.616 30.7585 37.3 30.7585C38.908 30.7585 40.0013 31.0345 40.58 31.5865C41.1573 32.1371 41.964 32.4771 43 32.6065V34.6825C41.792 34.5278 40.8333 34.1685 40.124 33.6045C39.4147 33.0405 38.4733 32.7585 37.3 32.7585C35.972 32.7585 34.9547 33.0918 34.248 33.7585C33.5413 34.4251 32.346 34.7585 30.662 34.7585C28.9927 34.7585 27.8033 34.4251 27.094 33.7585C26.3847 33.0918 25.3533 32.7591 24 32.7605C22.6307 32.7605 21.5993 33.0938 20.906 33.7605C20.2127 34.4271 19.0233 34.7605 17.338 34.7605C15.6527 34.7605 14.4613 34.4271 13.764 33.7605C13.0667 33.0938 12.0453 32.7605 10.7 32.7605C9.484 32.7605 8.54867 33.0425 7.894 33.6065C7.23933 34.1718 6.27467 34.5311 5 34.6845M5 27.1445V25.0685C6.036 24.9405 6.84267 24.6005 7.42 24.0485C7.99867 23.4978 9.092 23.2225 10.7 23.2225C12.3693 23.2225 13.5547 23.5558 14.256 24.2225C14.9573 24.8891 15.9847 25.2225 17.338 25.2225C18.7073 25.2225 19.7387 24.8891 20.432 24.2225C21.1253 23.5558 22.3147 23.2218 24 23.2205C25.6693 23.2205 26.856 23.5538 27.56 24.2205C28.264 24.8871 29.2907 25.2205 30.64 25.2205C32.008 25.2205 33.0387 24.8871 33.732 24.2205C34.4253 23.5538 35.6147 23.2205 37.3 23.2205C38.892 23.2205 39.9853 23.4965 40.58 24.0485C41.1733 24.5991 41.98 24.9385 43 25.0665V27.1425C41.7773 26.9891 40.8153 26.6305 40.114 26.0665C39.4127 25.5025 38.4747 25.2205 37.3 25.2205C35.972 25.2205 34.9547 25.5538 34.248 26.2205C33.5413 26.8871 32.346 27.2205 30.662 27.2205C28.9927 27.2205 27.8033 26.8871 27.094 26.2205C26.386 25.5538 25.3547 25.2205 24 25.2205C22.6307 25.2205 21.6033 25.5538 20.918 26.2205C20.2313 26.8871 19.046 27.2205 17.362 27.2205C15.678 27.2205 14.478 26.8871 13.762 26.2205C13.046 25.5538 12.0253 25.2205 10.7 25.2205C9.5 25.2205 8.56467 25.5025 7.894 26.0665C7.22333 26.6305 6.25867 26.9898 5 27.1445ZM5 19.6045V17.5285C6.036 17.4005 6.84267 17.0605 7.42 16.5085C7.99867 15.9578 9.092 15.6825 10.7 15.6825C12.3693 15.6825 13.5547 16.0158 14.256 16.6825C14.9573 17.3491 15.9847 17.6825 17.338 17.6825C18.7073 17.6825 19.7387 17.3491 20.432 16.6825C21.1253 16.0158 22.3147 15.6818 24 15.6805C25.6693 15.6805 26.856 16.0138 27.56 16.6805C28.264 17.3471 29.2907 17.6805 30.64 17.6805C32.008 17.6805 33.0387 17.3471 33.732 16.6805C34.4253 16.0138 35.6147 15.6805 37.3 15.6805C38.892 15.6805 39.9853 15.9558 40.58 16.5065C41.1733 17.0585 41.98 17.3985 43 17.5265V19.6025C41.7773 19.4491 40.8153 19.0905 40.114 18.5265C39.4127 17.9625 38.4747 17.6805 37.3 17.6805C35.972 17.6805 34.9547 18.0138 34.248 18.6805C33.5413 19.3471 32.346 19.6805 30.662 19.6805C28.9927 19.6805 27.8033 19.3471 27.094 18.6805C26.386 18.0138 25.3547 17.6805 24 17.6805C22.6307 17.6805 21.6033 18.0138 20.918 18.6805C20.2313 19.3471 19.046 19.6805 17.362 19.6805C15.678 19.6805 14.478 19.3471 13.762 18.6805C13.046 18.0138 12.0253 17.6805 10.7 17.6805C9.5 17.6805 8.552 17.9625 7.856 18.5265C7.16 19.0905 6.208 19.4498 5 19.6045Z"
                          fill="var(--c-primary)"
                        />
                      </svg>
                    </span>
                    <span v-else>
                      <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_481_37820)">
                          <path
                            d="M44.9467 23.2738L24.9467 3.27383C24.6969 3.0255 24.359 2.88611 24.0067 2.88611C23.6545 2.88611 23.3165 3.0255 23.0667 3.27383L3.0667 23.2738C2.84827 23.5289 2.73413 23.857 2.74709 24.1926C2.76005 24.5281 2.89916 24.8465 3.13662 25.0839C3.37408 25.3214 3.6924 25.4605 4.02797 25.4734C4.36353 25.4864 4.69163 25.3723 4.9467 25.1538L24 6.1005L43.0534 25.1672C43.3084 25.3856 43.6365 25.4997 43.9721 25.4868C44.3077 25.4738 44.626 25.3347 44.8635 25.0972C45.1009 24.8598 45.24 24.5415 45.253 24.2059C45.2659 23.8703 45.1518 23.5422 44.9334 23.2872L44.9467 23.2738Z"
                            fill="var(--c-primary)"
                          />
                          <path
                            d="M37.3333 42.8872H30.6667V29.5538H17.3333V42.8872H10.6667V24.2205L8 26.8872V42.8872C8 43.5944 8.28095 44.2727 8.78105 44.7728C9.28115 45.2729 9.95942 45.5538 10.6667 45.5538H20V32.2205H28V45.5538H37.3333C38.0406 45.5538 38.7189 45.2729 39.219 44.7728C39.7191 44.2727 40 43.5944 40 42.8872V26.5672L37.3333 23.9005V42.8872Z"
                            fill="var(--c-primary)"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_481_37820">
                            <rect width="48" height="48" fill="white" transform="translate(0 0.220459)" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <div>
                      <h6 class="n-title-primary tw-uppercase">{{ criteria.title }}</h6>
                      <p>{{ criteria.value }}</p>
                    </div>
                  </div>
                </div>
                <library-text class="property-description tw-mt-10 tw-text-sm" :html="property.description" />
              </div>

              <!-- MATTERPORT -->
              <div v-if="activeTabV3.name === 'matterport_video'" class="tw-pb-8">
                <h2 class="tw-pb-4">
                  {{ vars.matterportTitleText ? vars.matterportTitleText : 'VIRTUAL TOUR' }}
                </h2>
                <library-iframe :src="property?.virtual_tour?.mediaLink" />
              </div>

              <!-- FLOOR PLANS -->
              <div v-if="activeTabV3.name === 'floor_plan'" class="tw-pb-8">
                <h2 class="tw-pb-4">FLOOR PLANS</h2>
                <floor-plan :data="property.floor_plans" :component="component" />
              </div>

              <!-- MAP -->
              <div v-if="activeTabV3.name === 'map'" class="tw-pb-8">
                <h2 class="tw-pb-4">MAP</h2>
                <neuron-google-map
                  v-if="property.map_position && property.map_position.lat && property.map_position.lng"
                  v-model:map-center-position="property.map_position"
                  :component="component"
                  :marker-color="markerColor"
                />
              </div>

              <!-- EPC -->
              <div v-if="activeTabV3.name === 'epc' && property?.epcs?.length" class="tw-pb-8">
                <h4 class="tw-pb-4">EPC</h4>
                <epc :data="property.epcs" :component="component" />
              </div>
            </div>
          </div>

          <!-- Sağ kolon  -->
          <div
            v-if="sidebarComponents && sidebarComponents.length"
            class="tw-col-span-12 tw-pt-6 lg:tw-col-span-5 xl:tw-col-span-4"
          >
            <div class="tw-flex tw-flex-col tw-gap-4">
              <div v-if="vars.viewingOptionsBool">
                <div
                  class="tw-relative tw-flex tw-w-full tw-flex-col tw-justify-center tw-gap-5 tw-px-4 tw-py-9 tw-text-start"
                  :style="`background-color: var(--c-sidebar-card); border-radius: var(--rounded);`"
                >
                  <h3>{{ vars.viewingOptionsTitleText }}</h3>
                  <p v-if="vars.viewingOptionsDescriptionText">
                    {{ vars.viewingOptionsDescriptionText }}
                  </p>
                  <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-4">
                    <button :class="`n-${vars.viewingOptionsButton1TypeText} tw-w-fit`" @click="onVidePopup()">
                      {{ vars.viewingOptionsButton1LabelText }}
                    </button>
                    <button :class="`n-${vars.viewingOptionsButton2TypeText} tw-w-fit`" @click="onSendLead()">
                      {{ vars.viewingOptionsButton2LabelText }}
                    </button>
                  </div>
                </div>
              </div>
              <theme6-available-components-for-sidebar
                key="property-detail-sidebar"
                key-prefix="property-detail-sidebar"
                :specific-components="sidebarComponents"
              />
            </div>
          </div>
        </div>
      </div>

      <full-screen-gallery
        v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
        v-model:active-media-index="activeMediaIndex"
        :component="component"
        :active-media="activeMedia"
        :count-of-medias="property.medias.length"
        @close="closeLightbox()"
      />

      <popup :config="videoPopupConfig" custom-width="800px" @close="stopVideo">
        <template #content>
          <div class="tw-relative tw-pt-6">
            <library-iframe
              :src="videoPopupConfig.videoPopupSrc"
              frameborder="0"
              allowfullscreen
              :blur="imageBlurFilter"
              :pre-market-blur-text="preMarketBlurText"
            ></library-iframe>
          </div>
        </template>
      </popup>

      <popup :config="sendLeadPopupConfig" custom-width="800px">
        <template #content>
          <send-lead
            v-if="sendLeadPopupConfig.isActive"
            :property="property"
            @on-success="onSuccess"
            @close="sendLeadPopupConfig.isActive = false"
          />
        </template>
      </popup>

      <popup :config="successModalConfig" @close="onSuccessModalClosed()">
        <template #content>
          <success :text="successPopupText" />
        </template>
      </popup>
    </section>

    <section
      v-if="property && variants.v4 === variant"
      class="n-section-primary !tw-pb-0 !tw-pt-36 lg:!tw-pt-44"
      :style="{
        backgroundColor: vars.backgroundColor ? `var(--c-${vars.backgroundColor})` : 'var(--c-section_secondary)',
      }"
    >
      <div class="property-detail-info tw-flex tw-w-full tw-flex-col tw-py-4">
        <div class="tw-flex tw-justify-between tw-pb-6">
          <library-properties-back-to-all-properties-navbar :text="vars.backButtonText" color="var(--c-primary)" />
        </div>
      </div>

      <template v-if="vars.galleryVersionText === 'v2'">
        <div
          v-if="property.is_rent"
          class="tw-mt-16 tw-w-full"
          :class="!isMobileDevice ? 'tw-grid tw-grid-cols-12 tw-gap-x-3' : ''"
        >
          <div
            v-if="!isMobileDevice"
            class="property-detail-image-container tw-col-span-12 tw-h-full tw-w-full lg:tw-col-span-6"
            @click="onClickedImage(null)"
          >
            <library-image
              v-if="primaryFivePhotos[0].background"
              :src="primaryFivePhotos[0].background"
              image-class="tw-h-full tw-cursor-pointer"
              alt="property first image"
              :title="property.advert_heading"
              @click="onClickedImage(primaryFivePhotos[0])"
              :design-width="964"
              :design-height="643"
              :style="`border-radius: var(--rounded)`"
            >
              <template #overlay-item>
                <div class="nc-first-image-overlay-item">
                  <div v-if="property && property.medias" style="" class="tw-text-md tw-px-2 tw-py-1">
                    1/{{ property.medias.length }}
                  </div>
                </div>
              </template>
            </library-image>
          </div>
          <div
            v-if="!isMobileDevice"
            class="tw-col-span-12 tw-grid tw-h-full tw-grid-cols-12 tw-gap-x-3 md:tw-col-span-6"
          >
            <div class="tw-col-span-6 tw-flex tw-flex-row tw-gap-y-3 md:tw-flex-col">
              <library-image
                v-if="primaryFivePhotos[1].background"
                :src="primaryFivePhotos[1].background"
                alt="property first image"
                image-class="tw-cursor-pointer"
                @click="onClickedImage(primaryFivePhotos[1])"
                :title="property.advert_heading"
                :design-width="364"
                :design-height="246"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />

              <library-image
                v-if="primaryFivePhotos[2].background"
                :src="primaryFivePhotos[2].background"
                alt="property second image"
                image-class="tw-cursor-pointer"
                @click="onClickedImage(primaryFivePhotos[2])"
                :title="property.advert_heading"
                :design-width="364"
                :design-height="246"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />
            </div>
            <div class="tw-col-span-6 tw-flex tw-flex-row tw-gap-y-3 md:tw-flex-col">
              <library-image
                v-if="primaryFivePhotos[3].background"
                :src="primaryFivePhotos[3].background"
                image-class="tw-cursor-pointer"
                @click="onClickedImage(primaryFivePhotos[3])"
                :design-width="364"
                :design-height="246"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />
              <library-image
                v-if="primaryFivePhotos[4].background"
                :src="primaryFivePhotos[4].background"
                image-class="tw-cursor-pointer"
                @click="onClickedImage(primaryFivePhotos[4])"
                :design-width="364"
                :design-height="246"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />
            </div>
          </div>
          <div v-else-if="isMobileDevice" class="n-main-container tw-w-screen">
            <Swiper
              :modules="[SwiperNavigation]"
              :pagination="true"
              :slides-per-view="1"
              :space-between="1"
              effect="fade"
              :clickable="true"
              :navigation="{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              }"
              :loop="true"
              class="tw-w-full"
              @swiper="onSwiper"
            >
              <SwiperSlide v-for="(item, index) in primaryFivePhotos" :key="index" class="tw-w-full">
                <library-image
                  :src="item.background"
                  @click="onClickedImage(item)"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
              </SwiperSlide>
              <div class="tw-flex tw-items-center tw-justify-between">
                <div class="swiper-button-prev tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3">
                  <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18.75 7.5H5.25C4.83 7.5 4.5 7.17 4.5 6.75C4.5 6.33 4.83 6 5.25 6H18.75C19.17 6 19.5 6.33 19.5 6.75C19.5 7.17 19.17 7.5 18.75 7.5Z"
                      fill="black"
                    />
                    <path
                      d="M9 12.75C8.90164 12.7512 8.80411 12.7318 8.71369 12.6931C8.62328 12.6543 8.54197 12.5971 8.475 12.525L3.225 7.275C2.925 6.975 2.925 6.51 3.225 6.21L8.475 0.975C8.775 0.675 9.24 0.675 9.54 0.975C9.84 1.275 9.84 1.74 9.54 2.04L4.815 6.765L9.54 11.49C9.84 11.79 9.84 12.255 9.54 12.555C9.39 12.705 9.195 12.78 9.015 12.78L9 12.75Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div class="swiper-button-next tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3">
                  <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M5.25 7.5H18.75C19.17 7.5 19.5 7.17 19.5 6.75C19.5 6.33 19.17 6 18.75 6H5.25C4.83 6 4.5 6.33 4.5 6.75C4.5 7.17 4.83 7.5 5.25 7.5Z"
                      fill="black"
                    />
                    <path
                      d="M15 12.75C15.0984 12.7512 15.1959 12.7318 15.2863 12.6931C15.3767 12.6543 15.458 12.5971 15.525 12.525L20.775 7.275C21.075 6.975 21.075 6.51 20.775 6.21L15.525 0.975C15.225 0.675 14.76 0.675 14.46 0.975C14.16 1.275 14.16 1.74 14.46 2.04L19.185 6.765L14.46 11.49C14.16 11.79 14.16 12.255 14.46 12.555C14.61 12.705 14.805 12.78 14.985 12.78L15 12.75Z"
                      fill="black"
                    />
                  </svg>
                </div>
              </div>
            </Swiper>
          </div>
        </div>
        <!-- Sale -->
        <div v-else class="tw-w-screen tw-gap-x-1">
          <Swiper
            :modules="[SwiperNavigation]"
            :pagination="true"
            :centered-slides="true"
            :center-insufficient-slides="true"
            :loop="true"
            :initial-slide="0"
            :slides-per-view="2"
            :space-between="16"
            effect="fade"
            :clickable="true"
            :navigation="{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }"
            :breakpoints="{
              320: {
                slidesPerView: 1,
                spaceBetween: 8,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
            }"
            class="tw-w-full lg:tw-w-[100%]"
            @swiper="onSwiper"
          >
            <SwiperSlide
              v-for="(item, index) in property.medias.filter(
                (media) => !media.isVirtualTour && !media.background.includes('ytimg'),
              )"
              :key="index"
            >
              <div v-if="!item.background.includes('ytimg')">
                <library-image
                  v-if="!item.isVirtualTour || (!item.background.includes('ytimg') && item.background)"
                  :src="item.background"
                  @click="onClickedImage(item)"
                  :design-width="964"
                  :design-height="643"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                >
                  <template #overlay-item>
                    <div v-if="index === 0">
                      <div class="nc-first-image-overlay-item">
                        <div v-if="property && property.medias" style="" class="tw-text-md tw-px-2 tw-py-1">
                          1/{{ property.medias.length }}
                        </div>
                      </div>
                    </div>
                  </template>
                </library-image>
              </div>
            </SwiperSlide>

            <div class="tw-flex tw-items-center tw-justify-between">
              <div
                class="swiper-button-prev tw-cursor-pointer tw-rounded-full tw-bg-white tw-px-2 tw-py-5 lg:!tw-left-16 lg:tw-px-2"
              >
                <svg width="33" height="12" viewBox="0 0 33 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M31.5 5.25H32.25V6.75H31.5V5.25ZM0.96967 6.53033C0.676777 6.23744 0.676777 5.76256 0.96967 5.46967L5.74264 0.696699C6.03553 0.403806 6.51041 0.403806 6.8033 0.696699C7.09619 0.989592 7.09619 1.46447 6.8033 1.75736L2.56066 6L6.8033 10.2426C7.09619 10.5355 7.09619 11.0104 6.8033 11.3033C6.51041 11.5962 6.03553 11.5962 5.74264 11.3033L0.96967 6.53033ZM31.5 6.75H1.5V5.25H31.5V6.75Z"
                    fill="#545454"
                  />
                </svg>
              </div>
              <div
                class="swiper-button-next tw-cursor-pointer tw-rounded-full tw-bg-white tw-px-2 tw-py-5 lg:!tw-right-16 lg:tw-px-2"
              >
                <svg width="33" height="12" viewBox="0 0 33 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.5 5.25H0.75V6.75H1.5V5.25ZM32.0303 6.53033C32.3232 6.23744 32.3232 5.76256 32.0303 5.46967L27.2574 0.696699C26.9645 0.403806 26.4896 0.403806 26.1967 0.696699C25.9038 0.989593 25.9038 1.46447 26.1967 1.75736L30.4393 6L26.1967 10.2426C25.9038 10.5355 25.9038 11.0104 26.1967 11.3033C26.4896 11.5962 26.9645 11.5962 27.2574 11.3033L32.0303 6.53033ZM1.5 6.75H31.5V5.25H1.5V6.75Z"
                    fill="#545454"
                  />
                </svg>
              </div>
            </div>
          </Swiper>
        </div>
      </template>

      <div class="tw-mt-6 tw-grid tw-grid-cols-12 tw-items-start tw-justify-between lg:tw-mt-12">
        <div class="tw-col-span-12 tw-flex tw-flex-col lg:tw-col-span-7 lg:tw-gap-y-4">
          <h2 class="tw-uppercase">{{ property.advert_heading }}</h2>
          <div class="address tw-mt-2 tw-flex tw-items-center tw-gap-1">
            <h6 class="tw-uppercase" style="color: var(--c-text_primary) !important">
              {{ property.display_address }}
            </h6>
          </div>
          <div v-if="!property.is_locked" class="tw-mt-5 tw-flex tw-items-center tw-gap-1">
            <div class="rooms tw-flex tw-flex-row tw-items-center tw-gap-4 lg:tw-gap-8">
              <div class="tw-flex tw-items-center tw-gap-1">
                <span
                  ><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M4.125 6.1875C4.125 5.27582 4.48716 4.40148 5.13182 3.75682C5.77648 3.11216 6.65082 2.75 7.5625 2.75H14.4375C15.3492 2.75 16.2235 3.11216 16.8682 3.75682C17.5128 4.40148 17.875 5.27582 17.875 6.1875V8.31875C18.6514 8.47724 19.3493 8.89913 19.8504 9.513C20.3515 10.1269 20.6252 10.8951 20.625 11.6875V18.5625C20.625 18.7448 20.5526 18.9197 20.4236 19.0486C20.2947 19.1776 20.1198 19.25 19.9375 19.25C19.7552 19.25 19.5803 19.1776 19.4514 19.0486C19.3224 18.9197 19.25 18.7448 19.25 18.5625V15.125H2.75V18.5625C2.75 18.7448 2.67757 18.9197 2.54864 19.0486C2.4197 19.1776 2.24484 19.25 2.0625 19.25C1.88016 19.25 1.7053 19.1776 1.57636 19.0486C1.44743 18.9197 1.375 18.7448 1.375 18.5625V11.6875C1.37484 10.8951 1.64848 10.1269 2.1496 9.513C2.65073 8.89913 3.34856 8.47724 4.125 8.31875V6.1875ZM2.75 13.75H19.25V11.6875C19.25 11.1405 19.0327 10.6159 18.6459 10.2291C18.2591 9.8423 17.7345 9.625 17.1875 9.625H4.8125C4.26549 9.625 3.74089 9.8423 3.35409 10.2291C2.9673 10.6159 2.75 11.1405 2.75 11.6875V13.75ZM16.5 6.1875C16.5 5.64049 16.2827 5.11589 15.8959 4.72909C15.5091 4.3423 14.9845 4.125 14.4375 4.125H7.5625C7.01549 4.125 6.49089 4.3423 6.10409 4.72909C5.7173 5.11589 5.5 5.64049 5.5 6.1875V8.25H6.875V7.5625C6.875 7.38016 6.94743 7.2053 7.07636 7.07636C7.2053 6.94743 7.38016 6.875 7.5625 6.875H9.625C9.80734 6.875 9.9822 6.94743 10.1111 7.07636C10.2401 7.2053 10.3125 7.38016 10.3125 7.5625V8.25H11.6875V7.5625C11.6875 7.38016 11.7599 7.2053 11.8889 7.07636C12.0178 6.94743 12.1927 6.875 12.375 6.875H14.4375C14.6198 6.875 14.7947 6.94743 14.9236 7.07636C15.0526 7.2053 15.125 7.38016 15.125 7.5625V8.25H16.5V6.1875Z"
                      fill="black"
                    />
                  </svg>
                </span>
                <h6>{{ property.bedroom }}</h6>
              </div>
              <div class="tw-flex tw-items-center tw-gap-1">
                <span
                  ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M20.9184 3.08042C20.4813 2.64492 19.8895 2.40039 19.2726 2.40039C18.6556 2.40039 18.0638 2.64492 17.6268 3.08042L15.1752 5.52602L15.168 5.53322C13.8546 4.88969 12.3763 4.66143 10.93 4.8788C9.48364 5.09617 8.1378 5.74886 7.07157 6.75002C6.5875 6.64826 6.08352 6.70559 5.63467 6.91345C5.18582 7.12131 4.81611 7.4686 4.58061 7.90359C4.34511 8.33857 4.25641 8.838 4.32773 9.32747C4.39904 9.81695 4.62655 10.2703 4.97637 10.62L13.38 19.0248C13.7298 19.375 14.1834 19.6028 14.6732 19.6741C15.1631 19.7455 15.6628 19.6566 16.098 19.4207C16.5332 19.1848 16.8805 18.8146 17.0881 18.3653C17.2957 17.9159 17.3525 17.4115 17.25 16.9272C18.2512 15.8608 18.9038 14.5146 19.121 13.068C19.3381 11.6215 19.1095 10.143 18.4656 8.82962L18.4728 8.82122L20.9184 6.38162C21.1359 6.16528 21.3085 5.90808 21.4263 5.62482C21.5441 5.34155 21.6047 5.03779 21.6047 4.73102C21.6047 4.42424 21.5441 4.12048 21.4263 3.83721C21.3085 3.55395 21.1359 3.29675 20.9184 3.08042ZM17.8272 7.77122C17.3816 7.15706 16.8417 6.6172 16.2276 6.17162L18.474 3.93002C18.578 3.8199 18.703 3.73178 18.8417 3.67089C18.9804 3.61 19.1299 3.57757 19.2813 3.57552C19.4328 3.57347 19.5831 3.60185 19.7234 3.65897C19.8637 3.71609 19.9911 3.80079 20.098 3.90805C20.2049 4.01532 20.2893 4.14296 20.346 4.28341C20.4027 4.42386 20.4306 4.57427 20.4281 4.72571C20.4256 4.87716 20.3927 5.02656 20.3314 5.16506C20.2701 5.30356 20.1816 5.42834 20.0712 5.53202L17.8272 7.77122ZM8.20197 7.35362C9.35357 6.41133 10.8142 5.93057 12.3003 6.00467C13.7865 6.07877 15.192 6.70243 16.2442 7.75459C17.2964 8.80674 17.92 10.2123 17.9941 11.6984C18.0682 13.1846 17.5875 14.6452 16.6452 15.7968L16.626 15.7776L8.22237 7.37402L8.20197 7.35362ZM7.34517 8.19362L15.8052 16.6548C16.0069 16.8639 16.1174 17.1446 16.1122 17.4351C16.107 17.7257 15.9867 18.0022 15.7776 18.204C15.5685 18.4058 15.2878 18.5162 14.9973 18.5111C14.7067 18.5059 14.4301 18.3855 14.2284 18.1764L5.82357 9.77162C5.62377 9.56783 5.51137 9.29413 5.51029 9.00873C5.5092 8.72334 5.61953 8.44879 5.81778 8.2435C6.01604 8.03821 6.28658 7.91838 6.57183 7.90951C6.85709 7.90065 7.13455 8.00344 7.34517 8.19602M8.22357 15.7788C8.33605 15.8913 8.39924 16.0439 8.39924 16.203C8.39924 16.3621 8.33605 16.5147 8.22357 16.6272L5.82357 19.0272C5.71107 19.1399 5.55841 19.2032 5.3992 19.2033C5.23998 19.2035 5.08724 19.1403 4.97457 19.0278C4.86191 18.9153 4.79855 18.7627 4.79844 18.6034C4.79833 18.4442 4.86147 18.2915 4.97397 18.1788L7.37397 15.7788C7.42971 15.7229 7.49592 15.6786 7.56881 15.6484C7.64171 15.6181 7.71985 15.6025 7.79877 15.6025C7.87769 15.6025 7.95584 15.6181 8.02873 15.6484C8.10163 15.6786 8.16784 15.7229 8.22357 15.7788ZM5.82357 14.2272C5.87928 14.1714 5.92345 14.1052 5.95357 14.0324C5.98369 13.9595 5.99916 13.8814 5.9991 13.8026C5.99905 13.7238 5.98347 13.6457 5.95324 13.5729C5.92302 13.5001 5.87876 13.4339 5.82297 13.3782C5.76719 13.3225 5.70097 13.2783 5.62812 13.2482C5.55526 13.2181 5.47718 13.2026 5.39835 13.2027C5.31951 13.2027 5.24146 13.2183 5.16864 13.2485C5.09583 13.2788 5.02968 13.323 4.97397 13.3788L2.57397 15.7788C2.51826 15.8346 2.47409 15.9008 2.44397 15.9737C2.41385 16.0465 2.39838 16.1246 2.39844 16.2034C2.39849 16.2823 2.41408 16.3603 2.4443 16.4331C2.47452 16.506 2.51879 16.5721 2.57457 16.6278C2.63036 16.6835 2.69657 16.7277 2.76943 16.7578C2.84228 16.7879 2.92036 16.8034 2.9992 16.8033C3.07803 16.8033 3.15609 16.7877 3.2289 16.7575C3.30172 16.7273 3.36786 16.683 3.42357 16.6272L5.82357 14.2272ZM10.6236 18.1788C10.7361 18.2913 10.7992 18.4439 10.7992 18.603C10.7992 18.7621 10.7361 18.9147 10.6236 19.0272L8.22357 21.4272C8.11107 21.5399 7.95841 21.6032 7.7992 21.6033C7.63998 21.6035 7.48724 21.5403 7.37457 21.4278C7.26191 21.3153 7.19855 21.1627 7.19844 21.0034C7.19833 20.8442 7.26147 20.6915 7.37397 20.5788L9.77397 18.1788C9.82971 18.1229 9.89592 18.0786 9.96881 18.0484C10.0417 18.0181 10.1199 18.0025 10.1988 18.0025C10.2777 18.0025 10.3558 18.0181 10.4287 18.0484C10.5016 18.0786 10.5678 18.1229 10.6236 18.1788Z"
                      fill="black"
                    />
                  </svg>
                </span>
                <h6>{{ property.bathroom }}</h6>
              </div>
              <div class="tw-flex tw-items-center tw-gap-1">
                <span
                  ><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.25 4C6.52065 4 5.82118 4.28973 5.30546 4.80546C4.78973 5.32118 4.5 6.02065 4.5 6.75V8.087C3.78808 8.25585 3.15396 8.65998 2.70027 9.234C2.24657 9.80801 1.99984 10.5183 2 11.25V14.25C1.9999 14.9361 2.2563 15.5975 2.71886 16.1043C3.18142 16.6111 3.81671 16.9266 4.5 16.989V18.25C4.5 18.4489 4.57902 18.6397 4.71967 18.7803C4.86032 18.921 5.05109 19 5.25 19C5.44891 19 5.63968 18.921 5.78033 18.7803C5.92098 18.6397 6 18.4489 6 18.25V17H18V18.25C18 18.4489 18.079 18.6397 18.2197 18.7803C18.3603 18.921 18.5511 19 18.75 19C18.9489 19 19.1397 18.921 19.2803 18.7803C19.421 18.6397 19.5 18.4489 19.5 18.25V16.989C20.1833 16.9266 20.8186 16.6111 21.2811 16.1043C21.7437 15.5975 22.0001 14.9361 22 14.25V11.25C22.0002 10.5183 21.7534 9.80801 21.2997 9.234C20.846 8.65998 20.2119 8.25585 19.5 8.087V6.75C19.5 6.02065 19.2103 5.32118 18.6945 4.80546C18.1788 4.28973 17.4793 4 16.75 4H7.25ZM19.25 15.5H4.75C4.06 15.5 3.5 14.94 3.5 14.25V11.25C3.5 10.7859 3.68437 10.3408 4.01256 10.0126C4.34075 9.68437 4.78587 9.5 5.25 9.5C5.71413 9.5 6.15925 9.68437 6.48744 10.0126C6.81563 10.3408 7 10.7859 7 11.25V11.75C7 12.164 7.336 12.5 7.75 12.5H16.25C16.4489 12.5 16.6397 12.421 16.7803 12.2803C16.921 12.1397 17 11.9489 17 11.75V11.25C17 10.7859 17.1844 10.3408 17.5126 10.0126C17.8408 9.68437 18.2859 9.5 18.75 9.5C19.2141 9.5 19.6592 9.68437 19.9874 10.0126C20.3156 10.3408 20.5 10.7859 20.5 11.25V14.25C20.5 14.94 19.94 15.5 19.25 15.5ZM18 8.087C17.3298 8.24604 16.7275 8.61389 16.28 9.13746C15.8324 9.66103 15.5628 10.3132 15.51 11H8.49C8.43719 10.3132 8.16756 9.66103 7.72002 9.13746C7.27248 8.61389 6.67017 8.24604 6 8.087V6.75C6 6.06 6.56 5.5 7.25 5.5H16.75C17.44 5.5 18 6.06 18 6.75V8.087Z"
                      fill="black"
                    />
                  </svg>
                </span>
                <h6>{{ property.reception }}</h6>
              </div>
            </div>
          </div>
        </div>

        <div
          class="tw-col-span-12 tw-flex tw-flex-row tw-justify-between tw-pt-10 lg:tw-col-span-5 lg:tw-items-end lg:tw-justify-end lg:tw-gap-8"
        >
          <div class="tw-col-span-6 tw-flex tw-w-full tw-items-center tw-justify-between lg:tw-justify-end lg:tw-gap-8">
            <div v-if="property.price">
              <h3 v-if="property.price.type.name" class="tw-uppercase">
                {{ property.price.type.name }}
              </h3>
              <h2>{{ property.price.price }}</h2>
            </div>
          </div>
          <div
            class="tw-flex tw-h-12 tw-w-12 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full lg:tw-hidden"
            style="background-color: transparent; border: 1px solid var(--c-primary)"
            @click="onShared()"
          >
            <span>
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.5386 3C19.9534 2.9998 19.3753 3.12802 18.845 3.37562C18.3147 3.62321 17.8452 3.98414 17.4697 4.43296C17.0941 4.88177 16.8216 5.40752 16.6713 5.97314C16.5211 6.53875 16.4968 7.13044 16.6002 7.70646L10.7786 11.7828C10.7495 11.8029 10.7216 11.8247 10.6949 11.848C10.1043 11.3863 9.39588 11.0999 8.65036 11.0214C7.90484 10.9429 7.15226 11.0754 6.47844 11.404C5.80462 11.7325 5.23669 12.2438 4.83939 12.8795C4.4421 13.5152 4.23145 14.2497 4.23145 14.9994C4.23145 15.749 4.4421 16.4836 4.83939 17.1193C5.23669 17.755 5.80462 18.2663 6.47844 18.5948C7.15226 18.9233 7.90484 19.0559 8.65036 18.9774C9.39588 18.8989 10.1043 18.6125 10.6949 18.1508C10.7215 18.1745 10.7495 18.1967 10.7786 18.2172L16.6002 22.2935C16.4273 23.2569 16.6137 24.2502 17.1241 25.0854C17.6344 25.9206 18.4333 26.5397 19.3694 26.8255C20.3055 27.1113 21.3139 27.0439 22.2037 26.6362C23.0935 26.2284 23.8029 25.5086 24.1976 24.613C24.5923 23.7173 24.645 22.708 24.3456 21.7762C24.0461 20.8443 23.4155 20.0546 22.5729 19.5565C21.7304 19.0584 20.7344 18.8865 19.7737 19.0734C18.8129 19.2603 17.954 19.7929 17.3595 20.5705L11.8469 16.712C12.0931 16.1926 12.2309 15.6129 12.2309 15C12.2309 14.3871 12.0931 13.8062 11.8469 13.288L17.3608 9.42831C17.7738 9.96895 18.3179 10.3953 18.9416 10.6671C19.5654 10.9388 20.2481 11.047 20.9253 10.9813C21.6024 10.9157 22.2517 10.6784 22.8116 10.2919C23.3715 9.90545 23.8236 9.38253 24.1251 8.77263C24.4266 8.16273 24.5676 7.48601 24.5347 6.80646C24.5017 6.1269 24.296 5.46697 23.937 4.88907C23.5779 4.31117 23.0774 3.8344 22.4828 3.50385C21.8881 3.17329 21.219 2.99988 20.5386 3ZM18.3848 7C18.3848 6.42876 18.6117 5.88093 19.0156 5.477C19.4195 5.07308 19.9674 4.84615 20.5386 4.84615C21.1099 4.84615 21.6577 5.07308 22.0616 5.477C22.4655 5.88093 22.6925 6.42876 22.6925 7C22.6925 7.57124 22.4655 8.11907 22.0616 8.523C21.6577 8.92692 21.1099 9.15385 20.5386 9.15385C19.9674 9.15385 19.4195 8.92692 19.0156 8.523C18.6117 8.11907 18.3848 7.57124 18.3848 7ZM8.23093 12.8462C7.6597 12.8462 7.11186 13.0731 6.70793 13.477C6.30401 13.8809 6.07709 14.4288 6.07709 15C6.07709 15.5712 6.30401 16.1191 6.70793 16.523C7.11186 16.9269 7.6597 17.1538 8.23093 17.1538C8.80217 17.1538 9.35001 16.9269 9.75393 16.523C10.1579 16.1191 10.3848 15.5712 10.3848 15C10.3848 14.4288 10.1579 13.8809 9.75393 13.477C9.35001 13.0731 8.80217 12.8462 8.23093 12.8462ZM20.5386 20.8462C19.9674 20.8462 19.4195 21.0731 19.0156 21.477C18.6117 21.8809 18.3848 22.4288 18.3848 23C18.3848 23.5712 18.6117 24.1191 19.0156 24.523C19.4195 24.9269 19.9674 25.1538 20.5386 25.1538C21.1099 25.1538 21.6577 24.9269 22.0616 24.523C22.4655 24.1191 22.6925 23.5712 22.6925 23C22.6925 22.4288 22.4655 21.8809 22.0616 21.477C21.6577 21.0731 21.1099 20.8462 20.5386 20.8462Z"
                  fill="var(--c-primary)"
                />
              </svg>
            </span>
          </div>
        </div>
        <div
          class="tw-col-span-12 tw-flex tw-w-full tw-flex-col tw-items-start tw-gap-5 tw-py-5 md:tw-flex-row md:tw-items-center lg:tw-mt-8"
        >
          <button v-if="!property.is_locked" class="n-primary tw-w-full md:tw-w-auto" @click="onSendLead()">
            BOOK A VIEWING
          </button>
          <!-- <button @click="href('cinematic_videography')" class="n-secondary">CINEMATIC VIDEOGRAPHY</button> -->
        </div>
      </div>

      <!-- GALLERY: START -->
      <!-- GALLERY: END -->

      <!-- variant v1 for gallery -->
      <template v-if="vars.galleryVersionText === 'v1'">
        <div v-if="featuredVideo" class="tw-w-screen tw-px-4 tw-py-5">
          <div v-if="!isMobileDevice" class="tw-grid tw-grid-cols-[2.25fr_6.5fr_3.25fr] tw-gap-5">
            <div class="tw-relative">
              <div class="tw-aspect-[9/16] tw-h-full tw-w-full">
                <library-iframe
                  class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
                  :src="featuredVideo"
                  frameborder="0"
                  allowfullscreen
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                ></library-iframe>
              </div>
            </div>

            <div>
              <library-image
                v-if="primaryFivePhotos[0].background"
                :src="primaryFivePhotos[0].background"
                image-class="tw-h-full tw-cursor-pointer"
                alt="property first image"
                :title="property.advert_heading"
                @click="onClickedImage(primaryFivePhotos[0])"
                :design-width="998"
                :design-height="659"
                :style="`border-radius: var(--rounded);`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              >
                <template #overlay-item>
                  <div class="nc-first-image-overlay-item">
                    <div
                      v-if="property && property.medias"
                      style="
                        border-radius: var(--rounded-sm);
                        color: var(--c-text-primary);
                        background-color: var(--c-section_primary);
                      "
                      class="tw-text-md tw-px-2 tw-py-1"
                    >
                      1/{{ property.medias.length }}
                    </div>
                  </div>
                </template>
              </library-image>
            </div>

            <div class="tw-flex tw-flex-col tw-justify-between">
              <library-image
                v-if="primaryFivePhotos[1].background"
                :src="primaryFivePhotos[1].background"
                alt="property first image"
                image-class="tw-cursor-pointer"
                @click="onClickedImage(primaryFivePhotos[1])"
                :title="property.advert_heading"
                :design-width="472"
                :design-height="319"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />

              <library-image
                v-if="primaryFivePhotos[2].background"
                :src="primaryFivePhotos[2].background"
                alt="property first image"
                image-class="tw-cursor-pointer"
                @click="onClickedImage(primaryFivePhotos[2])"
                :title="property.advert_heading"
                :design-width="472"
                :design-height="319"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              >
                <template #overlay-item>
                  <div
                    v-if="property && property.medias"
                    class="tw-absolute tw-inset-0 tw-z-10 tw-h-full tw-w-full tw-bg-black tw-opacity-30"
                    style="border-radius: var(--rounded-sm)"
                  ></div>
                  <button
                    class="tw-z-20 tw-px-4 tw-py-2"
                    style="background-color: var(--c-input); color: var(--c-text-secondary)"
                  >
                    SEE ALL PHOTOS
                  </button>
                </template>
              </library-image>
            </div>
          </div>
          <div v-else-if="isMobileDevice">
            <div class="tw-relative tw-pb-4">
              <div class="tw-aspect-[9/16] tw-h-full tw-w-full">
                <library-iframe
                  class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
                  :src="property.featured_video?.mediaLink"
                  style="border-radius: var(--rounded)"
                  :w-ratio="9"
                  :h-ratio="16"
                  frameborder="0"
                  allowfullscreen
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                ></library-iframe>
              </div>
            </div>
            <Swiper
              :modules="[SwiperNavigation]"
              :pagination="true"
              :slides-per-view="1"
              :space-between="1"
              effect="fade"
              :clickable="true"
              :loop="true"
              :navigation="{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              }"
              class="tw-mt-6 tw-w-full"
              @swiper="onSwiper"
            >
              <SwiperSlide v-for="(item, index) in primaryFivePhotos" :key="index" class="tw-w-full">
                <library-image
                  :src="item.background"
                  @click="onClickedImage(item)"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
              </SwiperSlide>
              <div class="tw-flex tw-items-center tw-justify-between">
                <div class="swiper-button-prev tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3">
                  <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18.75 7.5H5.25C4.83 7.5 4.5 7.17 4.5 6.75C4.5 6.33 4.83 6 5.25 6H18.75C19.17 6 19.5 6.33 19.5 6.75C19.5 7.17 19.17 7.5 18.75 7.5Z"
                      fill="black"
                    />
                    <path
                      d="M9 12.75C8.90164 12.7512 8.80411 12.7318 8.71369 12.6931C8.62328 12.6543 8.54197 12.5971 8.475 12.525L3.225 7.275C2.925 6.975 2.925 6.51 3.225 6.21L8.475 0.975C8.775 0.675 9.24 0.675 9.54 0.975C9.84 1.275 9.84 1.74 9.54 2.04L4.815 6.765L9.54 11.49C9.84 11.79 9.84 12.255 9.54 12.555C9.39 12.705 9.195 12.78 9.015 12.78L9 12.75Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div class="swiper-button-next tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3">
                  <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M5.25 7.5H18.75C19.17 7.5 19.5 7.17 19.5 6.75C19.5 6.33 19.17 6 18.75 6H5.25C4.83 6 4.5 6.33 4.5 6.75C4.5 7.17 4.83 7.5 5.25 7.5Z"
                      fill="black"
                    />
                    <path
                      d="M15 12.75C15.0984 12.7512 15.1959 12.7318 15.2863 12.6931C15.3767 12.6543 15.458 12.5971 15.525 12.525L20.775 7.275C21.075 6.975 21.075 6.51 20.775 6.21L15.525 0.975C15.225 0.675 14.76 0.675 14.46 0.975C14.16 1.275 14.16 1.74 14.46 2.04L19.185 6.765L14.46 11.49C14.16 11.79 14.16 12.255 14.46 12.555C14.61 12.705 14.805 12.78 14.985 12.78L15 12.75Z"
                      fill="black"
                    />
                  </svg>
                </div>
              </div>
            </Swiper>
          </div>
        </div>
        <div v-else class="tw-w-screen tw-px-4">
          <div class="tw-mt-16 tw-w-full" :class="!isMobileDevice ? 'tw-grid tw-grid-cols-12 tw-gap-x-3' : ''">
            <div
              v-if="!isMobileDevice"
              class="property-detail-image-container tw-col-span-12 tw-h-full tw-w-full lg:tw-col-span-6"
              @click="onClickedImage(null)"
            >
              <library-image
                :src="primarySevenPhotos[0].background"
                image-class="tw-h-full tw-cursor-pointer"
                alt="property first image"
                :title="property.advert_heading"
                @click="onClickedImage(primarySevenPhotos[0])"
                :design-width="948"
                :design-height="626"
                :style="`border-radius: var(--rounded)`"
                :blur="imageBlurFilter"
                :pre-market-blur-text="preMarketBlurText"
              />
            </div>

            <div
              v-if="!isMobileDevice"
              class="tw-col-span-12 tw-grid tw-h-full tw-grid-cols-12 tw-gap-x-3 md:tw-col-span-6"
            >
              <div class="tw-col-span-6 tw-flex tw-flex-row tw-gap-y-3 md:tw-flex-col">
                <library-image
                  :src="primarySevenPhotos[1].background"
                  alt="property first image"
                  image-class="tw-cursor-pointer"
                  @click="onClickedImage(primarySevenPhotos[1])"
                  :title="property.advert_heading"
                  :design-width="448"
                  :design-height="303"
                  :style="`border-radius: var(--rounded)`"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />

                <library-image
                  :src="primarySevenPhotos[2].background"
                  alt="property second image"
                  image-class="tw-cursor-pointer"
                  @click="onClickedImage(primarySevenPhotos[2])"
                  :title="property.advert_heading"
                  :design-width="448"
                  :design-height="303"
                  :style="`border-radius: var(--rounded)`"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
              </div>
              <div class="tw-col-span-6 tw-flex tw-flex-row tw-gap-y-3 md:tw-flex-col">
                <library-image
                  :src="primarySevenPhotos[3].background"
                  image-class="tw-cursor-pointer"
                  @click="onClickedImage(primarySevenPhotos[4])"
                  :design-width="448"
                  :design-height="303"
                  :style="`border-radius: var(--rounded)`"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />

                <library-image
                  :src="primarySevenPhotos[4].background"
                  alt="property second image"
                  image-class="tw-cursor-pointer"
                  @click="onClickedImage(primarySevenPhotos[6])"
                  :title="property.advert_heading"
                  :design-width="448"
                  :design-height="303"
                  :style="`border-radius: var(--rounded)`"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                >
                  <template #overlay-item>
                    <div
                      v-if="property && property.medias"
                      class="tw-absolute tw-inset-0 tw-z-10 tw-h-full tw-w-full tw-bg-black tw-opacity-30"
                      style="border-radius: var(--rounded-sm)"
                    ></div>
                    <button
                      class="tw-z-20 tw-px-4 tw-py-2"
                      style="background-color: var(--c-section_primary); color: var(--c-text-primary)"
                    >
                      SEE ALL PHOTOS
                    </button>
                  </template>
                </library-image>
              </div>
            </div>
            <div v-else-if="isMobileDevice" class="n-main-container tw-w-screen">
              <Swiper
                :modules="[SwiperNavigation]"
                :pagination="true"
                :loop="true"
                :slides-per-view="1"
                :space-between="1"
                effect="fade"
                :clickable="true"
                :navigation="{
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }"
                class="tw-w-full"
                @swiper="onSwiper"
              >
                <SwiperSlide v-for="(item, index) in primaryFivePhotos" :key="index" class="tw-w-full">
                  <library-image
                    :src="item.background"
                    @click="onClickedImage(item)"
                    :blur="imageBlurFilter"
                    :pre-market-blur-text="preMarketBlurText"
                  />
                </SwiperSlide>
                <div class="tw-flex tw-items-center tw-justify-between">
                  <div
                    class="swiper-button-prev tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3"
                  >
                    <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M18.75 7.5H5.25C4.83 7.5 4.5 7.17 4.5 6.75C4.5 6.33 4.83 6 5.25 6H18.75C19.17 6 19.5 6.33 19.5 6.75C19.5 7.17 19.17 7.5 18.75 7.5Z"
                        fill="black"
                      />
                      <path
                        d="M9 12.75C8.90164 12.7512 8.80411 12.7318 8.71369 12.6931C8.62328 12.6543 8.54197 12.5971 8.475 12.525L3.225 7.275C2.925 6.975 2.925 6.51 3.225 6.21L8.475 0.975C8.775 0.675 9.24 0.675 9.54 0.975C9.84 1.275 9.84 1.74 9.54 2.04L4.815 6.765L9.54 11.49C9.84 11.79 9.84 12.255 9.54 12.555C9.39 12.705 9.195 12.78 9.015 12.78L9 12.75Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                  <div
                    class="swiper-button-next tw-cursor-pointer tw-rounded-md tw-bg-white tw-px-2 tw-py-5 lg:tw-px-3"
                  >
                    <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M5.25 7.5H18.75C19.17 7.5 19.5 7.17 19.5 6.75C19.5 6.33 19.17 6 18.75 6H5.25C4.83 6 4.5 6.33 4.5 6.75C4.5 7.17 4.83 7.5 5.25 7.5Z"
                        fill="black"
                      />
                      <path
                        d="M15 12.75C15.0984 12.7512 15.1959 12.7318 15.2863 12.6931C15.3767 12.6543 15.458 12.5971 15.525 12.525L20.775 7.275C21.075 6.975 21.075 6.51 20.775 6.21L15.525 0.975C15.225 0.675 14.76 0.675 14.46 0.975C14.16 1.275 14.16 1.74 14.46 2.04L19.185 6.765L14.46 11.49C14.16 11.79 14.16 12.255 14.46 12.555C14.61 12.705 14.805 12.78 14.985 12.78L15 12.75Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                </div>
              </Swiper>
            </div>
          </div>
        </div>
      </template>
      <!-- tabs -->
      <template v-if="!property.is_locked">
        <ul
          v-if="variant === variants.v1"
          class="nav nav-tabs pxp-nav-tabs tw-my-8 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-10 lg:tw-flex-row"
        >
          <li v-for="(tab, tabIndex) in tabs" :key="`tab-${tabIndex}`" class="nav-item">
            <div
              :class="activeTab.name === tab.name ? 'active' : ''"
              class="nav-link tw-cursor-pointer tw-font-bold"
              data-toggle="tab"
              @click="
                () => {
                  activeTab.name = tab.name;
                  activeTab.title = tab.title;
                }
              "
            >
              {{ tab.title }}
            </div>
          </li>
        </ul>
      </template>
      <template v-else-if="property.is_locked">
        <library-login />
      </template>
      <ul
        class="nav nav-tabs pxp-nav-tabs sticky-nav tw-flex tw-w-full tw-flex-col tw-flex-wrap tw-items-center tw-justify-center tw-transition-all tw-duration-200 min-[480px]:tw-text-center md:tw-gap-4 lg:tw-mt-6 lg:tw-flex-row lg:tw-flex-nowrap lg:tw-gap-5 lg:tw-gap-x-20"
        :class="isScrolled ? 'tw-bg-white lg:tw-fixed lg:tw-top-20 lg:tw-z-30 lg:tw-shadow-sm' : ''"
        v-if="variant === variants.v4 && !property.is_locked"
        ref="navTabs"
      >
        <li v-for="(tab, tabIndex) in tabsV2" :key="`tab2-${tabIndex}`" class="nav-item">
          <div
            :class="activeTabV2.name === tab.name ? 'active' : ''"
            class="nav-link tw-cursor-pointer"
            data-toggle="tab"
            @click="
              () => {
                activeTabV2.name = tab.name;
              }
            "
          >
            <nuxt-link :to="`#${tab.name}`" class="n-link"
              ><h4>{{ tab.title }}</h4></nuxt-link
            >
          </div>
        </li>
      </ul>

      <!-- tabs end -->
    </section>

    <section
      v-if="variant === variants.v4 && !property.is_locked"
      class="n-section-primary tw-mt-10 !tw-pt-0"
      style="background-color: var(--c-section_primary)"
    >
      <div class="tw-w-full">
        <div class="tw-grid tw-grid-cols-12 md:tw-gap-x-10">
          <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-7 xl:tw-col-span-8">
            <div class="tab-content tw-mt-6">
              <!-- CINEMATIC VIDEO -->
              <div id="cinematic_videography" v-if="featuredVideo" class="tw-pb-8 md:tw-mt-10">
                <h2 class="tw-pb-4">CINEMATIC VIDEOGRAPHY</h2>
                <library-iframe
                  :src="featuredVideo"
                  :blur="imageBlurFilter"
                  :pre-market-blur-text="preMarketBlurText"
                />
              </div>

              <!-- FEATURES -->
              <div id="features" class="tw-pb-8 md:tw-mt-10">
                <h2 class="tw-pb-4">FEATURES</h2>
                <div v-if="property?.features" class="tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-4">
                  <div
                    v-for="(feature, index) in property.features"
                    :key="`property-feature-v3-${index}`"
                    class="tw-col-span-12 tw-flex tw-items-start tw-gap-x-3 md:tw-col-span-6 xl:tw-col-span-4"
                  >
                    <span>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                          fill="var(--c-primary)"
                        />
                      </svg>
                    </span>
                    <library-text class="tw-text-sm tw-uppercase" :text="feature" />
                  </div>
                </div>
              </div>

              <!-- PROPERTY INFO -->
              <div id="property_information" class="tw-pb-8 md:tw-mt-10">
                <h2 class="tw-pb-4">PROPERTY INFO</h2>
                <div
                  v-if="property?.criteria_list"
                  class="tw-mt-4 tw-flex tw-flex-col tw-gap-4 md:tw-mt-8 md:tw-flex-row md:tw-flex-wrap md:tw-gap-6"
                >
                  <div
                    v-for="criteria in property.criteria_list"
                    :key="criteria.id"
                    class="tw-flex tw-gap-4 tw-py-2 md:tw-p-4"
                    style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                  >
                    <span v-if="criteria.title === 'Parking'">
                      <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M45 21.5955H42.7312L37.4231 9.65358C37.2168 9.18982 36.8805 8.79581 36.4549 8.51927C36.0293 8.24273 35.5326 8.09552 35.025 8.09546H12.975C12.4674 8.09552 11.9707 8.24273 11.5451 8.51927C11.1195 8.79581 10.7832 9.18982 10.5769 9.65358L5.26875 21.5955H3C2.70163 21.5955 2.41548 21.714 2.2045 21.925C1.99353 22.1359 1.875 22.4221 1.875 22.7205C1.875 23.0188 1.99353 23.305 2.2045 23.516C2.41548 23.7269 2.70163 23.8455 3 23.8455H4.875V39.2205C4.875 39.9167 5.15156 40.5843 5.64384 41.0766C6.13613 41.5689 6.80381 41.8455 7.5 41.8455H12C12.6962 41.8455 13.3639 41.5689 13.8562 41.0766C14.3484 40.5843 14.625 39.9167 14.625 39.2205V35.8455H33.375V39.2205C33.375 39.9167 33.6516 40.5843 34.1438 41.0766C34.6361 41.5689 35.3038 41.8455 36 41.8455H40.5C41.1962 41.8455 41.8639 41.5689 42.3562 41.0766C42.8484 40.5843 43.125 39.9167 43.125 39.2205V23.8455H45C45.2984 23.8455 45.5845 23.7269 45.7955 23.516C46.0065 23.305 46.125 23.0188 46.125 22.7205C46.125 22.4221 46.0065 22.1359 45.7955 21.925C45.5845 21.714 45.2984 21.5955 45 21.5955ZM12.6319 10.5686C12.6613 10.5021 12.7094 10.4457 12.7703 10.4061C12.8312 10.3665 12.9023 10.3454 12.975 10.3455H35.025C35.0977 10.3454 35.1688 10.3665 35.2297 10.4061C35.2906 10.4457 35.3387 10.5021 35.3681 10.5686L40.2694 21.5955H7.73063L12.6319 10.5686ZM12.375 39.2205C12.375 39.3199 12.3355 39.4153 12.2652 39.4856C12.1948 39.556 12.0995 39.5955 12 39.5955H7.5C7.40054 39.5955 7.30516 39.556 7.23483 39.4856C7.16451 39.4153 7.125 39.3199 7.125 39.2205V35.8455H12.375V39.2205ZM40.5 39.5955H36C35.9005 39.5955 35.8052 39.556 35.7348 39.4856C35.6645 39.4153 35.625 39.3199 35.625 39.2205V35.8455H40.875V39.2205C40.875 39.3199 40.8355 39.4153 40.7652 39.4856C40.6948 39.556 40.5995 39.5955 40.5 39.5955ZM40.875 33.5955H7.125V23.8455H40.875V33.5955ZM10.875 28.7205C10.875 28.4221 10.9935 28.1359 11.2045 27.925C11.4155 27.714 11.7016 27.5955 12 27.5955H15C15.2984 27.5955 15.5845 27.714 15.7955 27.925C16.0065 28.1359 16.125 28.4221 16.125 28.7205C16.125 29.0188 16.0065 29.305 15.7955 29.516C15.5845 29.7269 15.2984 29.8455 15 29.8455H12C11.7016 29.8455 11.4155 29.7269 11.2045 29.516C10.9935 29.305 10.875 29.0188 10.875 28.7205ZM31.875 28.7205C31.875 28.4221 31.9935 28.1359 32.2045 27.925C32.4155 27.714 32.7016 27.5955 33 27.5955H36C36.2984 27.5955 36.5845 27.714 36.7955 27.925C37.0065 28.1359 37.125 28.4221 37.125 28.7205C37.125 29.0188 37.0065 29.305 36.7955 29.516C36.5845 29.7269 36.2984 29.8455 36 29.8455H33C32.7016 29.8455 32.4155 29.7269 32.2045 29.516C31.9935 29.305 31.875 29.0188 31.875 28.7205Z"
                          fill="var(--c-primary)"
                        />
                      </svg>
                    </span>

                    <span v-else-if="criteria.title === 'Sewerage'">
                      <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M43.5 20.0955H38.625V10.3455H43.5C43.7984 10.3455 44.0845 10.2269 44.2955 10.016C44.5065 9.80498 44.625 9.51883 44.625 9.22046C44.625 8.92209 44.5065 8.63594 44.2955 8.42496C44.0845 8.21399 43.7984 8.09546 43.5 8.09546H38.3681C38.1555 7.6472 37.8202 7.26837 37.4011 7.00289C36.9819 6.7374 36.4961 6.59614 36 6.59546H33C32.5039 6.59614 32.0181 6.7374 31.5989 7.00289C31.1798 7.26837 30.8445 7.6472 30.6319 8.09546H27C21.9296 8.10141 17.0685 10.1183 13.4832 13.7036C9.89782 17.289 7.88095 22.15 7.875 27.2205V30.8523C7.42674 31.065 7.04791 31.4003 6.78243 31.8194C6.51694 32.2385 6.37568 32.7243 6.375 33.2205V36.2205C6.37568 36.7166 6.51694 37.2024 6.78243 37.6215C7.04791 38.0406 7.42674 38.376 7.875 38.5886V43.7205C7.875 44.0188 7.99353 44.305 8.2045 44.516C8.41548 44.7269 8.70163 44.8455 9 44.8455C9.29837 44.8455 9.58452 44.7269 9.7955 44.516C10.0065 44.305 10.125 44.0188 10.125 43.7205V38.8455H19.875V43.7205C19.875 44.0188 19.9935 44.305 20.2045 44.516C20.4155 44.7269 20.7016 44.8455 21 44.8455C21.2984 44.8455 21.5845 44.7269 21.7955 44.516C22.0065 44.305 22.125 44.0188 22.125 43.7205V38.5886C22.5733 38.376 22.9521 38.0406 23.2176 37.6215C23.4831 37.2024 23.6243 36.7166 23.625 36.2205V33.2205C23.6243 32.7243 23.4831 32.2385 23.2176 31.8194C22.9521 31.4003 22.5733 31.065 22.125 30.8523V27.2205C22.125 25.9275 22.6386 24.6876 23.5529 23.7733C24.4671 22.8591 25.7071 22.3455 27 22.3455H30.6319C30.8445 22.7937 31.1798 23.1726 31.5989 23.438C32.0181 23.7035 32.5039 23.8448 33 23.8455H36C36.4961 23.8448 36.9819 23.7035 37.4011 23.438C37.8202 23.1726 38.1555 22.7937 38.3681 22.3455H43.5C43.7984 22.3455 44.0845 22.2269 44.2955 22.016C44.5065 21.805 44.625 21.5188 44.625 21.2205C44.625 20.9221 44.5065 20.6359 44.2955 20.425C44.0845 20.214 43.7984 20.0955 43.5 20.0955ZM21 32.8455C21.0995 32.8455 21.1948 32.885 21.2652 32.9553C21.3355 33.0256 21.375 33.121 21.375 33.2205V36.2205C21.375 36.3199 21.3355 36.4153 21.2652 36.4856C21.1948 36.556 21.0995 36.5955 21 36.5955H9C8.90054 36.5955 8.80516 36.556 8.73483 36.4856C8.66451 36.4153 8.625 36.3199 8.625 36.2205V33.2205C8.625 33.121 8.66451 33.0256 8.73483 32.9553C8.80516 32.885 8.90054 32.8455 9 32.8455H21ZM19.875 27.2205V30.5955H10.125V27.2205C10.13 22.7465 11.9095 18.4571 15.0731 15.2935C18.2367 12.1299 22.526 10.3504 27 10.3455H30.375V20.0955H27C25.1103 20.0955 23.2981 20.8461 21.9619 22.1823C20.6257 23.5185 19.875 25.3308 19.875 27.2205ZM36 21.5955H33C32.9005 21.5955 32.8052 21.556 32.7348 21.4856C32.6645 21.4153 32.625 21.3199 32.625 21.2205V9.22046C32.625 9.121 32.6645 9.02562 32.7348 8.95529C32.8052 8.88497 32.9005 8.84546 33 8.84546H36C36.0995 8.84546 36.1948 8.88497 36.2652 8.95529C36.3355 9.02562 36.375 9.121 36.375 9.22046V21.2205C36.375 21.3199 36.3355 21.4153 36.2652 21.4856C36.1948 21.556 36.0995 21.5955 36 21.5955Z"
                          fill="var(--c-primary)"
                        />
                      </svg>
                    </span>

                    <span v-else-if="criteria.title === 'Water'">
                      <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M5 34.6805V32.6045C6.036 32.4765 6.84267 32.1365 7.42 31.5845C7.99867 31.0338 9.092 30.7585 10.7 30.7585C12.3853 30.7585 13.5747 31.0918 14.268 31.7585C14.9613 32.4251 15.9847 32.7585 17.338 32.7585C18.7073 32.7585 19.7387 32.4251 20.432 31.7585C21.1253 31.0918 22.3147 30.7585 24 30.7585C25.6693 30.7585 26.8587 31.0918 27.568 31.7585C28.2773 32.4251 29.3087 32.7585 30.662 32.7585C32.0313 32.7585 33.0587 32.4251 33.744 31.7585C34.4307 31.0918 35.616 30.7585 37.3 30.7585C38.908 30.7585 40.0013 31.0345 40.58 31.5865C41.1573 32.1371 41.964 32.4771 43 32.6065V34.6825C41.792 34.5278 40.8333 34.1685 40.124 33.6045C39.4147 33.0405 38.4733 32.7585 37.3 32.7585C35.972 32.7585 34.9547 33.0918 34.248 33.7585C33.5413 34.4251 32.346 34.7585 30.662 34.7585C28.9927 34.7585 27.8033 34.4251 27.094 33.7585C26.3847 33.0918 25.3533 32.7591 24 32.7605C22.6307 32.7605 21.5993 33.0938 20.906 33.7605C20.2127 34.4271 19.0233 34.7605 17.338 34.7605C15.6527 34.7605 14.4613 34.4271 13.764 33.7605C13.0667 33.0938 12.0453 32.7605 10.7 32.7605C9.484 32.7605 8.54867 33.0425 7.894 33.6065C7.23933 34.1718 6.27467 34.5311 5 34.6845M5 27.1445V25.0685C6.036 24.9405 6.84267 24.6005 7.42 24.0485C7.99867 23.4978 9.092 23.2225 10.7 23.2225C12.3693 23.2225 13.5547 23.5558 14.256 24.2225C14.9573 24.8891 15.9847 25.2225 17.338 25.2225C18.7073 25.2225 19.7387 24.8891 20.432 24.2225C21.1253 23.5558 22.3147 23.2218 24 23.2205C25.6693 23.2205 26.856 23.5538 27.56 24.2205C28.264 24.8871 29.2907 25.2205 30.64 25.2205C32.008 25.2205 33.0387 24.8871 33.732 24.2205C34.4253 23.5538 35.6147 23.2205 37.3 23.2205C38.892 23.2205 39.9853 23.4965 40.58 24.0485C41.1733 24.5991 41.98 24.9385 43 25.0665V27.1425C41.7773 26.9891 40.8153 26.6305 40.114 26.0665C39.4127 25.5025 38.4747 25.2205 37.3 25.2205C35.972 25.2205 34.9547 25.5538 34.248 26.2205C33.5413 26.8871 32.346 27.2205 30.662 27.2205C28.9927 27.2205 27.8033 26.8871 27.094 26.2205C26.386 25.5538 25.3547 25.2205 24 25.2205C22.6307 25.2205 21.6033 25.5538 20.918 26.2205C20.2313 26.8871 19.046 27.2205 17.362 27.2205C15.678 27.2205 14.478 26.8871 13.762 26.2205C13.046 25.5538 12.0253 25.2205 10.7 25.2205C9.5 25.2205 8.56467 25.5025 7.894 26.0665C7.22333 26.6305 6.25867 26.9898 5 27.1445ZM5 19.6045V17.5285C6.036 17.4005 6.84267 17.0605 7.42 16.5085C7.99867 15.9578 9.092 15.6825 10.7 15.6825C12.3693 15.6825 13.5547 16.0158 14.256 16.6825C14.9573 17.3491 15.9847 17.6825 17.338 17.6825C18.7073 17.6825 19.7387 17.3491 20.432 16.6825C21.1253 16.0158 22.3147 15.6818 24 15.6805C25.6693 15.6805 26.856 16.0138 27.56 16.6805C28.264 17.3471 29.2907 17.6805 30.64 17.6805C32.008 17.6805 33.0387 17.3471 33.732 16.6805C34.4253 16.0138 35.6147 15.6805 37.3 15.6805C38.892 15.6805 39.9853 15.9558 40.58 16.5065C41.1733 17.0585 41.98 17.3985 43 17.5265V19.6025C41.7773 19.4491 40.8153 19.0905 40.114 18.5265C39.4127 17.9625 38.4747 17.6805 37.3 17.6805C35.972 17.6805 34.9547 18.0138 34.248 18.6805C33.5413 19.3471 32.346 19.6805 30.662 19.6805C28.9927 19.6805 27.8033 19.3471 27.094 18.6805C26.386 18.0138 25.3547 17.6805 24 17.6805C22.6307 17.6805 21.6033 18.0138 20.918 18.6805C20.2313 19.3471 19.046 19.6805 17.362 19.6805C15.678 19.6805 14.478 19.3471 13.762 18.6805C13.046 18.0138 12.0253 17.6805 10.7 17.6805C9.5 17.6805 8.552 17.9625 7.856 18.5265C7.16 19.0905 6.208 19.4498 5 19.6045Z"
                          fill="var(--c-primary)"
                        />
                      </svg>
                    </span>
                    <span v-else>
                      <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_481_37820)">
                          <path
                            d="M44.9467 23.2738L24.9467 3.27383C24.6969 3.0255 24.359 2.88611 24.0067 2.88611C23.6545 2.88611 23.3165 3.0255 23.0667 3.27383L3.0667 23.2738C2.84827 23.5289 2.73413 23.857 2.74709 24.1926C2.76005 24.5281 2.89916 24.8465 3.13662 25.0839C3.37408 25.3214 3.6924 25.4605 4.02797 25.4734C4.36353 25.4864 4.69163 25.3723 4.9467 25.1538L24 6.1005L43.0534 25.1672C43.3084 25.3856 43.6365 25.4997 43.9721 25.4868C44.3077 25.4738 44.626 25.3347 44.8635 25.0972C45.1009 24.8598 45.24 24.5415 45.253 24.2059C45.2659 23.8703 45.1518 23.5422 44.9334 23.2872L44.9467 23.2738Z"
                            fill="var(--c-primary)"
                          />
                          <path
                            d="M37.3333 42.8872H30.6667V29.5538H17.3333V42.8872H10.6667V24.2205L8 26.8872V42.8872C8 43.5944 8.28095 44.2727 8.78105 44.7728C9.28115 45.2729 9.95942 45.5538 10.6667 45.5538H20V32.2205H28V45.5538H37.3333C38.0406 45.5538 38.7189 45.2729 39.219 44.7728C39.7191 44.2727 40 43.5944 40 42.8872V26.5672L37.3333 23.9005V42.8872Z"
                            fill="var(--c-primary)"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_481_37820">
                            <rect width="48" height="48" fill="white" transform="translate(0 0.220459)" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <div>
                      <h6 class="n-title-primary tw-uppercase">{{ criteria.title }}</h6>
                      <p>{{ criteria.value }}</p>
                    </div>
                  </div>
                </div>
                <library-text class="property-description tw-mt-10 tw-text-sm" :html="property.description" />
              </div>

              <!-- MATTERPORT -->
              <div id="matterport_video" v-if="matterPort" class="tw-pb-8 md:tw-mt-10">
                <h2 class="tw-pb-4">MATTERPORT VIDEO</h2>
                <library-iframe :src="matterPort" />
              </div>

              <!-- FLOOR PLANS -->
              <div id="floor_plan" class="tw-pb-8 md:tw-mt-10">
                <h2 class="tw-pb-4">FLOOR PLANS</h2>
                <floor-plan :data="property.floor_plans" :component="component" />
              </div>

              <!-- MAP -->
              <div id="map" class="tw-pb-8 md:tw-mt-10">
                <h2 class="tw-pb-4">MAP</h2>
                <neuron-google-map
                  v-if="property.map_position && property.map_position.lat && property.map_position.lng"
                  v-model:map-center-position="property.map_position"
                  :component="component"
                  :marker-color="markerColor"
                />
              </div>

              <!-- EPC -->
              <div id="epc" v-if="property?.epcs?.length" class="tw-mt-5 tw-pb-8 md:tw-mt-10">
                <h2 class="tw-pb-4">EPC</h2>
                <epc :data="property.epcs" :component="component" />
              </div>
            </div>
          </div>

          <!-- Sağ kolon  -->
          <div
            v-if="sidebarComponents && sidebarComponents.length"
            class="tw-col-span-12 tw-pt-6 lg:tw-col-span-5 xl:tw-col-span-4"
          >
            <div class="tw-flex tw-flex-col tw-gap-4">
              <div v-if="vars.viewingOptionsBool">
                <div
                  class="tw-relative tw-flex tw-w-full tw-flex-col tw-justify-center tw-gap-5 tw-px-4 tw-py-9 tw-text-start"
                  :style="`background-color: var(--c-sidebar-card); border-radius: var(--rounded);`"
                >
                  <h3>{{ vars.viewingOptionsTitleText }}</h3>
                  <p v-if="vars.viewingOptionsDescriptionText">
                    {{ vars.viewingOptionsDescriptionText }}
                  </p>
                  <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-4">
                    <button :class="`n-${vars.viewingOptionsButton1TypeText} tw-w-fit`" @click="onVidePopup()">
                      {{ vars.viewingOptionsButton1LabelText }}
                    </button>
                    <button :class="`n-${vars.viewingOptionsButton2TypeText} tw-w-fit`" @click="onSendLead()">
                      {{ vars.viewingOptionsButton2LabelText }}
                    </button>
                  </div>
                </div>
              </div>
              <theme6-available-components-for-sidebar
                key="property-detail-sidebar"
                key-prefix="property-detail-sidebar"
                :specific-components="sidebarComponents"
              />
            </div>
          </div>
        </div>
      </div>

      <full-screen-gallery
        v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias"
        v-model:active-media-index="activeMediaIndex"
        :component="component"
        :active-media="activeMedia"
        :count-of-medias="property.medias.length"
        @close="closeLightbox()"
      />

      <popup :config="videoPopupConfig" custom-width="800px" @close="stopVideo">
        <template #content>
          <div class="tw-relative tw-pt-6">
            <library-iframe
              :src="videoPopupConfig.videoPopupSrc"
              frameborder="0"
              allowfullscreen
              :blur="imageBlurFilter"
              :pre-market-blur-text="preMarketBlurText"
            ></library-iframe>
          </div>
        </template>
      </popup>

      <popup :config="sendLeadPopupConfig" custom-width="800px">
        <template #content>
          <send-lead
            v-if="sendLeadPopupConfig.isActive"
            :property="property"
            @on-success="onSuccess"
            @close="sendLeadPopupConfig.isActive = false"
          />
        </template>
      </popup>

      <popup :config="successModalConfig" @close="onSuccessModalClosed()">
        <template #content>
          <success :text="successPopupText" />
        </template>
      </popup>
    </section>

    <!-- Back To Top Button (variant 4 only) -->
    <button
      v-if="variant === variants.v4 && showBackToTop"
      class="n-primary tw-fixed tw-bottom-6 tw-right-6 tw-z-50 tw-rounded-full tw-px-4 tw-py-2 tw-text-xs tw-font-semibold tw-shadow-lg"
      @click="scrollToTop"
    >
      <span class="tw-flex tw-items-center tw-justify-center">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 19V5" />
          <polyline points="5 12 12 5 19 12" />
        </svg>
      </span>
    </button>
  </div>
</template>

<script lang="ts">
import { mapActions } from 'pinia';
import { ROUTES } from '~/constants/ui.constants';
import { usePropertiesStore } from '~/units/properties/stores';
import type { Component } from '~/types';
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertyMixin } from '~/units/properties/mixins/property.mixin';
import FloorPlan from '~/components/common/FloorPlan.vue';
import NeuronGoogleMap from '~/components/common/NeuronGoogleMap.vue';
import Epc from '~/components/common/Epc.vue';
import NcSelect from '~/components/common/inputs/NcSelect.vue';
import NcInput from '~/components/common/inputs/NcInput.vue';
import NcButton from '~/components/common/inputs/NcButton.vue';
import FullScreenGallery from '~/components/common/FullScreenGallery.vue';
import { useCoreStore } from '~/units/core/store';
import SendLead from '~/components/common/leads/SendLead.vue';
import Success from '~/components/common/popup/Success.vue';
import Popup from '~/components/common/popup/Popup.vue';
import PropertyDetailActions from '~/components/theme4/properties/PropertyDetailActions.vue';
import AvailableComponentsForSidebar from '~/components/theme4/AvailableComponentsForSidebar.vue';
import { FullScreenPopupMixin } from '~/units/core/mixins/fullScreenPopupMixin';
import { getImagesByCount } from '~/units/properties/store';
import { CompanyKeys } from '~/units/website/constants';

export default defineNuxtComponent({
  name: 'Theme6PropertyDetail',
  components: {
    AvailableComponentsForSidebar,
    PropertyDetailActions,
    Popup,
    Success,
    SendLead,
    FullScreenGallery,
    NcButton,
    NcInput,
    NcSelect,
    Epc,
    NeuronGoogleMap,
    FloorPlan,
  },

  mixins: [ComponentMixin, PropertyMixin, FullScreenPopupMixin],

  data() {
    return {
      activeTab: { name: 'features', title: 'FEATURES', is_visible: !!this.featuredVideo },
      activeTabV2: { name: 'features', title: 'FEATURES' },
      activeTabV3: { name: 'features', title: 'FEATURES' },
      swiper: {},
      isScrolled: false,
      scrollThreshold: 0,
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        v4: 'v4',
      },
      videoPopupConfig: {
        isActive: false,
        videoPopupSrc: this.featuredVideo,
      },
      showBackToTop: false,
    };
  },

  mounted() {
    this.setScrollThreshold();
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('scroll', this._handleBackToTopScroll, { passive: true });
    this.handleScroll();
  },

  computed: {
    tabs() {
      const tabs = [
        {
          name: 'features',
          title: 'FEATURES',
          is_visible: !!this.property?.features,
        },
        {
          name: 'property_information',
          title: 'PROPERTY INFO',
          is_visible: true,
        },
        {
          name: 'floor_plan',
          title: 'FLOOR PLANS',
          is_visible: !!this.property?.floor_plans?.length,
        },
        {
          name: 'map',
          title: 'MAP',
          is_visible: !!this.property.map_position,
        },
        {
          name: 'epc',
          title: 'EPC',
          is_visible: !!this.property?.epcs?.length,
        },
        {
          name: 'matterport_video',
          title: 'VIRTUAL TOUR',
          is_visible: !!this.matterPort,
        },
        {
          name: 'video_tour',
          title: 'VIDEO TOUR',
          is_visible: !!this.featuredVideo,
        },
      ];

      return tabs.filter((i) => i.is_visible);
    },

    tabsV2() {
      const tabs = [
        {
          name: 'cinematic_videography',
          title: 'CINEMATIC VIDEO',
          is_visible: !!this.featuredVideo,
        },
        {
          name: 'features',
          title: 'FEATURES',
          is_visible: !!this.property?.features,
        },
        {
          name: 'property_information',
          title: 'PROPERTY INFO',
          is_visible: true,
        },
        {
          name: 'floor_plan',
          title: 'FLOOR PLANS',
          is_visible: !!this.property?.floor_plans?.length,
        },
        {
          name: 'map',
          title: 'MAP',
          is_visible: !!this.property.map_position,
        },
        {
          name: 'epc',
          title: 'EPC',
          is_visible: !!this.property?.epcs?.length,
        },
        /*         {
          name: 'matterport_video',
          title: 'MATTERPORT VIDEO',
          is_visible: !!this.matterPort,
        }, */
      ];

      return tabs.filter((i) => i.is_visible);
    },

    tabsV3() {
      const tabs = [
        {
          name: 'cinematic_videography',
          title: 'CINEMATIC VIDEO',
          is_visible: !!this.featuredVideo,
        },
        {
          name: 'features',
          title: 'FEATURES',
          is_visible: !!this.property?.features,
        },
        {
          name: 'property_information',
          title: 'PROPERTY INFO',
          is_visible: true,
        },
        {
          name: 'floor_plan',
          title: 'FLOOR PLANS',
          is_visible: !!this.property?.floor_plans?.length,
        },
        {
          name: 'map',
          title: 'MAP',
          is_visible: !!this.property.map_position,
        },
        {
          name: 'epc',
          title: 'EPC',
          is_visible: !!this.property?.epcs?.length,
        },
        {
          name: 'matterport_video',
          title: 'VIRTUAL TOUR',
          is_visible: !!this.property?.virtual_tour?.mediaLink,
        },
      ];
      return tabs.filter((t) => t.is_visible);
    },

    markerColor() {
      return this.colors.primary;
    },

    ROUTES() {
      return ROUTES;
    },

    primaryFivePhotos() {
      if (this.property) {
        return getImagesByCount(this.property, 5);
      }
      return [];
    },

    primarySevenPhotos() {
      if (this.property) {
        return getImagesByCount(this.property, 7);
      }
      return [];
    },

    sidebarComponents(): Component[] {
      if (this.currentPage && this.currentPage.sidebar) {
        return this.currentPage.sidebar;
      }
      return [];
    },

    isMortgageCalculatorVisible() {
      return !this.vars.isMortgageCalculatorHiddenNumber;
    },

    isStampDutyCalculatorVisible() {
      return !this.vars.isStampDutyCalculatorHiddenNumber;
    },

    isLetterPropertyCriteria() {
      return this.vars.isLetterPropertyCriteriaNumber;
    },

    featuredVideo() {
      const mediaLink = this.property.featured_video?.mediaLink;
      if (mediaLink && mediaLink.includes('matterport')) {
        return null;
      }
      return mediaLink;
    },

    matterPort() {
      let mediaLink = this.property?.virtual_tour?.mediaLink;
      if (mediaLink && mediaLink.includes('youtu')) {
        return null;
      }
      if (mediaLink && mediaLink.startsWith('http://')) {
        mediaLink = mediaLink.replace('http://', 'https://');
      }
      return mediaLink;
    },
  },

  methods: {
    ...mapActions(useCoreStore, ['shareApi', 'openTab']),
    async onShared() {
      await this.shareApi({
        title: this.property?.advert_heading,
        text: this.property?.advert_heading,
        url: window.location.href,
      });
    },

    onSwiper(swiper: object) {
      this.swiper = swiper;
    },

    href(location) {
      this.activeTab.name = location;
    },

    handleScroll() {
      this.isScrolled = window.scrollY > this.scrollThreshold;
    },

    setScrollThreshold() {
      nextTick(() => {
        const ulElement = this.$refs.navTabs;
        if (ulElement) {
          this.scrollThreshold = ulElement.offsetTop - 90;
        }
      });
    },

    onVidePopup() {
      this.videoPopupConfig.isActive = !this.videoPopupConfig.isActive;
      this.videoPopupConfig.videoPopupSrc = this.featuredVideo;
    },

    stopVideo() {
      this.videoPopupConfig.videoPopupSrc = '';
    },

    _handleBackToTopScroll() {
      if (this.variant === this.variants.v4) {
        this.showBackToTop = window.scrollY > 400;
      } else if (this.showBackToTop) {
        this.showBackToTop = false;
      }
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },

  async setup(props: { component: Component }) {
    const store = usePropertiesStore();
    await store.fetchSingleProperty(props.component);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('scroll', this._handleBackToTopScroll);
  },
});
</script>

<style scoped>
.share-button {
  border: 2px solid var(--camel);
}

.nav-link.active {
  color: var(--purple);
  border-bottom-color: var(--purple);
}

.nav-link {
  color: var(--black);
  font-size: 16px;
}

.nc-first-image-overlay-item {
  position: absolute;
  bottom: 0.1rem;
  right: 0.1rem;
  transform: translate(-50%, -50%);
  text-align: right;
  background-color: var(--white);
  color: var(--nc-classic-black);
  border-radius: 4px;
}

.nc-all-photos-button {
  position: absolute;
  bottom: 20px;
  left: 70px;
  padding: 10px;
  border-radius: 4px;
  background-color: var(--white);
  color: var(--nc-classic-black);
}

.photo-next,
.photo-prev {
  position: absolute;
  top: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 44px;
  height: 64px;
  background-color: #fff;
  border-radius: var(--rounded);
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  font-size: 26px;
}

.photo-next {
  right: 5%;
}

.photo-prev {
  left: 5%;
}

::v-deep(.floor-tab .floor-plan-items .floor-plan-card) {
  width: 100% !important;
}

::v-deep(.floor-tab .floor-plan-items .floor-plan-card figure) {
  border: none !important;
}

::v-deep(.floor-tab) {
  padding: unset !important;
}

::v-deep(.inline-iframe-container iframe) {
  height: 590px;
}

.theme4-floor-plan ::v-deep(figure) {
  height: unset !important;
}

.swiper-button-next::after,
.swiper-button-prev::after {
  content: unset;
}
.swiper-button-next,
.swiper-button-prev {
  width: unset;
  height: unset;
}

::v-deep(img) {
  border-radius: 4px;
}

.property-detail-card {
  padding: 24px;
  border-radius: var(--rounded);
  background-color: var(--c-section_primary);
}

.property-detail-card.accordion {
  padding-bottom: 0;
  padding-top: 0;
}

@media screen and (min-width: 1024px) {
  .property-detail-card {
    padding: 32px;
  }

  .property-detail-card.accordion {
    padding-bottom: 0;
    padding-top: 0;
  }
}

.accordion-stamp-duty-calculator ::v-deep(h3),
.accordion-mortgage-calculator ::v-deep(h3) {
  display: none;
}

.accordion-stamp-duty-calculator ::v-deep(.stamp-duty-result),
.accordion-mortgage-calculator ::v-deep(.mortgage-result) {
  background: var(--c-primary);
  border-radius: var(--rounded);
}
.accordion-stamp-duty-calculator ::v-deep(select),
.accordion-stamp-duty-calculator ::v-deep(.n-input),
.accordion-stamp-duty-calculator ::v-deep(input),
.accordion-mortgage-calculator ::v-deep(select),
.accordion-mortgage-calculator ::v-deep(.n-input),
.accordion-mortgage-calculator ::v-deep(input) {
  background: var(--c-input_secondary) !important;
}

.nav-link:hover {
  color: var(--c-primary);
}

.active {
  color: var(--c-primary) !important;
}
/* TAB KUTUSU —  */
.v3-tabs {
  display: inline-flex;
  align-items: center;
  gap: 16px;
  padding: 10px 14px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

/* TAB item */
.v3-tab {
  position: relative;
  padding: 8px 10px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #000;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s ease;
}
.v3-tab:hover {
  color: rgba(0, 0, 0, 0.85);
}

/* Aktif renk ve alt çizgi */
.v3-tab.is-active {
  color: var(--c-primary);
}
.v3-tab.is-active::after {
  content: '';
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: 4px;
  height: 2px;
  border-radius: 2px;
  background: var(--c-primary);
}

/* Mobilde foto genişliğinde scroll */
@media (max-width: 1023px) {
  .v3-tabs {
    display: flex;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .v3-tabs::-webkit-scrollbar {
    display: none;
  }
}
</style>
